/*!
 * kma-chat.js — KMA Cosmetics Smart Guided Chat Widget v1.0
 * Vanilla JS · No dependencies · Deferred loading
 * Architecture: Config → State → Analytics → API → DataHelper → Renderer → Carousel → A11y → Widget
 */
(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════
     1. CONFIG — อ่าน settings จาก JSON data island ของ Liquid
     ══════════════════════════════════════════════════════════ */
  const Config = (function () {
    const el = document.getElementById('kma-chat-config');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  /* ══════════════════════════════════════════════════════════
     1.1 I18N — Bilingual Multi-Language Support (TH / EN)
     ══════════════════════════════════════════════════════════ */
  const isEn = (function () {
    const loc = (Config.locale || '').toLowerCase();
    const path = (window.location.pathname || '').toLowerCase();
    const htmlLang = (document.documentElement.lang || '').toLowerCase();
    return loc === 'en' || loc.startsWith('en-') || path.startsWith('/en') || path.includes('/en/') || htmlLang.startsWith('en');
  })();

  const currentLocale = isEn ? 'en' : 'th';

  const I18n = {
    th: {
      headerTitle: 'KMA Beauty Assistant',
      headerSubtitle: 'พร้อมช่วยคุณเลือกสิ่งที่ใช่',
      toggleLabel: 'สอบถาม KMA',
      tooltipText: 'มีอะไรให้ KMA ช่วยไหมคะ?',
      backToMainMenu: 'กลับไปที่เมนูหลัก',
      
      greetingBox1: 'สวัสดีค่ะ 💖 KMA พร้อมช่วยให้คุณค้นหาสิ่งที่ต้องการได้ง่ายขึ้น\nเลือกดูสินค้า โปรโมชั่น ติดตามคำสั่งซื้อ หรือบริการต่าง ๆ จากเมนูด้านล่างได้เลยค่ะ',
      greetingBox2: 'แชทนี้เป็นระบบตอบกลับอัตโนมัติของ KMA Cosmetics เพื่อช่วยให้คุณค้นหาข้อมูลและเข้าถึงบริการต่าง ๆ ได้สะดวกยิ่งขึ้น\n\nกรุณาอย่าส่งข้อมูลส่วนตัวหรือข้อมูลสำคัญ เช่น รหัสผ่าน ข้อมูลบัตรเครดิต หรือข้อมูลการชำระเงินผ่านช่องแชทนี้',
      greetingBox3: 'พร้อมแล้ว เลือกเรื่องที่ต้องการให้ KMA ช่วยได้เลยค่ะ ✨',

      menu_new_arrivals: '✨ สินค้าใหม่',
      menu_promotion: '🎁 โปรโมชั่น',
      menu_advisor: '💄 ช่วยแนะนำสินค้า',
      menu_store: '📍 ค้นหาสาขา',
      menu_tracking: '📦 ติดตามพัสดุ',
      menu_support: '💬 ติดต่อ KMA Support',

      storeLocatorWelcome: 'ยินดีต้อนรับสู่ KMA Store Locator ค่ะ 💖✨\nคุณลูกค้าสามารถเลือกค้นหาสาขาเคาน์เตอร์ KMA ใกล้บ้านได้จากตัวเลือกด้านล่างนี้นะคะ:',
      storeLocatorGps: '📍 ค้นหาสาขาใกล้ฉันที่สุด (GPS)',
      storeLocatorBkk: '🏢 กรุงเทพมหานคร (60 สาขา)',
      storeLocatorMetro: '🚗 5 จังหวัดปริมณฑล (26 สาขา)',
      storeLocatorEast: '🌴 ภาคตะวันออก (ชลบุรี / ระยอง)',
      storeLocatorIsan: '🌾 ภาคอีสาน (ขอนแก่น / โคราช)',
      storeLocatorSouth: '🌊 ภาคใต้ (ภูเก็ต / หาดใหญ่)',
      storeLocatorNorthCentral: '⛰️ ภาคเหนือ & กลาง (เชียงใหม่ / อยุธยา)',

      bkkPrompt: 'ใน **กรุงเทพมหานคร** มีจุดจำหน่ายเคาน์เตอร์ถึง 60 สาขาเลยค่ะ 💖\nคุณลูกค้าสะดวกเดินทางแถวโซนไหนคะ?',
      bkkCenter: '🏙️ ใจกลางเมือง (สยาม / พระราม 9 / สุขุมวิท / สีลม)',
      bkkNorth: '🚇 โซนเหนือ-ออก (ลาดพร้าว / จตุจักร / รามอินทรา / บางกะปิ)',
      bkkWest: '🌉 ฝั่งธน-ใต้ (ปิ่นเกล้า / บางแค / ท่าพระ / พระราม 2)',
      bkkEast: '🛍️ โซนตะวันออก (บางนา / ศรีนครินทร์ / พระโขนง)',
      backRegions: '🔙 เลือกดูภูมิภาคอื่น',

      metroPrompt: 'เลือกจังหวัดปริมณฑลที่คุณลูกค้าสะดวกเดินทางได้เลยค่ะ: 💖',
      backToBkk: '🔙 ย้อนกลับไปเลือกโซน กทม.',

      gpsNoSupport: 'ขออภัยด้วยนะคะ อุปกรณ์ของคุณลูกค้าไม่รองรับการระบุพิกัด GPS ค่ะ 💖\nกรุณาเลือกค้นหาตามจังหวัดหรือโซนที่สะดวกด้านล่างนี้นะคะ:',
      gpsLocating: 'กำลังระบุพิกัดและคำนวณหาร้าน KMA ที่อยู่ใกล้คุณลูกค้ามากที่สุดนะคะ... 📍✨',
      gpsNearbyHeader: '📍 พิกัดปัจจุบันของคุณลูกค้า อยู่ใกล้กับจุดจำหน่าย KMA เหล่านี้มากที่สุดค่ะ (เรียงตามระยะทาง):',
      gpsTooFar: 'คุณลูกค้าอยู่ห่างจากจุดจำหน่ายเคาน์เตอร์ หรือระบบไม่พบพิกัดที่ใกล้เคียงค่ะ 💖\nสามารถเลือกดูสาขาตามจังหวัดหรือสั่งซื้อออนไลน์ได้นะคะ ✨',
      gpsFallback: 'คุณลูกค้าสามารถเลือกค้นหาตามจังหวัด หรือโซนที่สะดวกเดินทางได้จากตัวเลือกด้านล่างนี้นะคะ: 💖',

      viewMapGoogle: '📍 ดูแผนที่ Google Maps',
      phonePrefix: '📞 โทร: ',
      hoursPrefix: '⏰ เวลาทำการ: ',
      approxDist: (km) => `(ห่าง ~${km} กม.)`,

      followUpPrompt: 'มีอะไรให้ทางเราช่วยดูแลเพิ่มเติมอีกไหมคะ? 💖',
      followUpYes: 'ใช่',
      followUpNo: 'ไม่ใช่',
      followUpShopAll: '🛍️ เลือกดูสินค้าทั้งหมด',
      followUpYesPrompt: 'ยินดีเลยค่ะ คุณลูกค้าต้องการให้ KMA ดูแลเรื่องใดต่อดีคะ? เลือกดูเมนูด้านล่างได้ตลอดเลยนะคะ ✨',
      followUpNoPrompt: 'ขอบคุณที่แวะมาพูดคุยกับ KMA นะคะ 💖 ขอให้มีความสุขกับการช้อปปิ้งและสวยมั่นใจในทุกวันค่ะ ✨\nหากต้องการสอบถามเรื่องใดเพิ่มเติม สามารถเลือกเมนูใหม่ได้ตลอดเวลานะคะ',

      backPrompt: 'เริ่มต้นเลือกเมนูด้านล่างที่คุณต้องการได้เลยค่ะ ✨',
      userBackHome: 'กลับไปที่เมนูหลัก',
      idleTimeout: 'ขออภัยด้วยนะคะ เนื่องจากไม่มีการตอบกลับสักครู่หนึ่ง ระบบขออนุญาตปิดบทสนทนานี้ก่อนนะคะ 💖\n\nหากคุณลูกค้าต้องการสอบถามข้อมูลเพิ่มเติมในภายหลัง สามารถทักแชทกลับมาหา KMA ได้ตลอดเวลาเลยนะคะ ยินดีให้บริการค่ะ ✨',

      lineChatCta: 'แชทกับเรา (LINE)',
      seePromoCta: 'ดูโปรโมชั่นนี้'
    },
    en: {
      headerTitle: 'KMA Beauty Assistant',
      headerSubtitle: 'Ready to help you find your match',
      toggleLabel: 'Ask KMA',
      tooltipText: 'How can KMA help you today?',
      backToMainMenu: 'Back to Main Menu',
      
      greetingBox1: 'Hello! 💖 Welcome to KMA Cosmetics!\nYour beauty assistant ready to help you find products, promotions, track orders, or locate our stores.',
      greetingBox2: 'This chat is an automated service by KMA Cosmetics to assist you quickly and conveniently.\n\nPlease do not submit sensitive personal information, passwords, or payment details through this chat.',
      greetingBox3: 'How can KMA assist you today? Please choose an option below ✨',

      menu_new_arrivals: '✨ New Arrivals',
      menu_promotion: '🎁 Promotions',
      menu_advisor: '💄 Product Advisor',
      menu_store: '📍 Store Locator',
      menu_tracking: '📦 Track Order',
      menu_support: '💬 Contact Support',

      storeLocatorWelcome: 'Welcome to KMA Store Locator 💖✨\nPlease select your preferred region or find the nearest counter below:',
      storeLocatorGps: '📍 Find Nearest Store (GPS)',
      storeLocatorBkk: '🏢 Bangkok (60 counters)',
      storeLocatorMetro: '🚗 5 Greater BKK Provinces (26 counters)',
      storeLocatorEast: '🌴 Eastern Region (Chonburi / Rayong)',
      storeLocatorIsan: '🌾 Northeastern (Khon Kaen / Korat)',
      storeLocatorSouth: '🌊 Southern Region (Phuket / Hatyai)',
      storeLocatorNorthCentral: '⛰️ Northern & Central (Chiang Mai / Ayutthaya)',

      bkkPrompt: 'In **Bangkok**, KMA has 60 beauty counters ready to welcome you 💖\nWhich area is most convenient for you?',
      bkkCenter: '🏙️ City Center (Siam / Rama 9 / Sukhumvit / Silom)',
      bkkNorth: '🚇 North-East BKK (Ladprao / Chatuchak / Ramintra / Bangkapi)',
      bkkWest: '🌉 West-South BKK (Pinklao / Bangkhae / Thaphra / Rama 2)',
      bkkEast: '🛍️ Eastern BKK (Bangna / Srinakarin / Phra Khanong)',
      backRegions: '🔙 Choose Another Region',

      metroPrompt: 'Please select a province in the Greater Bangkok area: 💖',
      backToBkk: '🔙 Back to Bangkok Zones',

      gpsNoSupport: 'Sorry, your device does not support GPS location services 💖\nPlease select your preferred region or zone below:',
      gpsLocating: 'Detecting your coordinates and finding the nearest KMA counters... 📍✨',
      gpsNearbyHeader: '📍 Closest KMA counters to your current location (sorted by distance):',
      gpsTooFar: 'You are currently far from our counter locations or coordinates could not be matched 💖\nYou can browse stores by province or shop online anytime ✨',
      gpsFallback: 'You can select your preferred province or zone from the options below: 💖',

      viewMapGoogle: '📍 View on Google Maps',
      phonePrefix: '📞 Tel: ',
      hoursPrefix: '⏰ Hours: ',
      approxDist: (km) => `(~${km} km away)`,

      followUpPrompt: 'Is there anything else KMA can help you with today? 💖',
      followUpYes: 'Yes',
      followUpNo: 'No',
      followUpShopAll: '🛍️ Shop All Products',
      followUpYesPrompt: 'Glad to help! What else would you like to explore? Choose an option below ✨',
      followUpNoPrompt: 'Thank you for chatting with KMA Cosmetics! 💖 Wishing you a wonderful day and happy shopping ✨\nWhenever you need assistance, feel free to chat with us anytime.',

      backPrompt: 'Please select an option below to get started ✨',
      userBackHome: 'Back to Main Menu',
      idleTimeout: 'Due to inactivity, this conversation is now paused 💖\n\nWhenever you need assistance, feel free to chat with KMA anytime! Have a wonderful day ✨',

      lineChatCta: 'Chat with Us (LINE)',
      seePromoCta: 'View Promotion'
    }
  };

  const t = (key, ...args) => {
    const lang = isEn ? 'en' : 'th';
    const val = (I18n[lang] && I18n[lang][key]) || (I18n['th'] && I18n['th'][key]) || key;
    if (typeof val === 'function') return val(...args);
    return val;
  };

  /* แปลงข้อความจาก Metaobjects / Dynamic Labels เป็นภาษาอังกฤษอัตโนมัติ */
  const localizeText = (text, handle, actionType) => {
    if (!isEn || !text) return text;
    const str = String(text).trim();
    const low = str.toLowerCase();
    const h = String(handle || '').toLowerCase();
    const a = String(actionType || '').toLowerCase();

    // 1. Main Navigation & Core Actions (Targeted matching, not greedy)
    if ((low === 'สินค้าใหม่' || low === 'new arrivals' || low.includes('สินค้าใหม่ล่าสุด')) || h.includes('new_arrival') || a === 'new_arrivals') return 'New Arrivals';
    if ((low === 'โปรโมชั่น' || low === 'โปรโมชัน' || low === 'promotions' || low.includes('โปรโมชั่นพิเศษ')) || h.includes('promo') || a === 'promotion') return 'Promotions';
    if ((low === 'แนะนำสินค้า' || low === 'ค้นหาเฉดสี' || low === 'ที่ปรึกษาความงาม' || low === 'product advisor') || h.includes('advisor') || a === 'advisor') return 'Product Advisor';
    if ((low === 'ค้นหาสาขา' || low === 'สาขา' || low === 'จุดจำหน่าย' || low === 'เช็คสาขา' || low === 'หาสาขา' || low === 'store locator') || h.includes('store') || h.includes('location') || a === 'find_store' || a === 'store' || a === 'store_locator') return 'Store Locator';
    if ((low === 'ติดตามพัสดุ' || low === 'เช็คสถานะพัสดุ' || low === 'สถานะพัสดุ' || low === 'track order') || h.includes('track') || a === 'tracking' || a === 'order_tracking') return 'Track Order';
    if ((low === 'อื่นๆ' || low === 'อื่น ๆ' || low === 'ติดต่อเรา' || low.includes('สอบถามเพิ่มเติม') || low === 'contact support') || h.includes('support') || h.includes('other') || a === 'support') return 'Support & Contact';

    // 2. Product Categories & Advisor
    if (low === 'รองพื้น' || low.includes('หมวดรองพื้น') || low === 'foundation') return 'Foundation';
    if (low === 'คุชชั่น' || low.includes('หมวดคุชชั่น') || low === 'cushion') return 'Cushion';
    if (low === 'แป้ง' || low.includes('หมวดแป้ง') || low === 'powder') return 'Powder';
    if (low === 'ไพรเมอร์' || low.includes('หมวดไพรเมอร์') || low === 'primer') return 'Primer';
    if (low === 'พอยต์เมคอัพ' || low === 'ลิปสติก' || low === 'บลัชออน' || low === 'point makeup') return 'Point Makeup';
    if (low === 'สกินแคร์' || low === 'บำรุงผิว' || low === 'skincare') return 'Skincare';
    if (low === 'อุปกรณ์แต่งหน้า' || low === 'แปรงแต่งหน้า' || low === 'makeup tools') return 'Makeup Tools';

    // 3. Support Subtopics
    if (low.includes('สั่งซื้อ') || low === 'order issues') return 'Order Issues';
    if (low.includes('ชำระเงิน') || low === 'payment') return 'Payment';
    if (low.includes('จัดส่ง') || low === 'shipping & delivery') return 'Shipping & Delivery';
    if (low.includes('เสียหาย') || low.includes('ผิด') || low === 'damaged / wrong items') return 'Damaged / Wrong Items';
    if (low.includes('ข้อมูลสินค้า') || low === 'product information') return 'Product Information';

    // 4. Common Dialog Buttons & Region Navigation
    if (low === 'ใช่' || low === 'yes') return 'Yes';
    if (low === 'ไม่ใช่' || low === 'no') return 'No';
    if (low.includes('เลือกดูภูมิภาคอื่น') || low.includes('ภูมิภาคอื่น') || low.includes('choose another region')) return '🔙 Choose Another Region';
    if (low.includes('เลือกดูจังหวัดอื่น') || low.includes('จังหวัดอื่น') || low.includes('choose another province')) return '🔙 Choose Another Province';
    if (low.includes('กลับไปที่เมนูหลัก') || low.includes('กลับเมนูหลัก') || low.includes('back to main menu')) return 'Back to Main Menu';
    if (low.includes('ดูสินค้าทั้งหมด') || low.includes('เลือกดูสินค้าทั้งหมด') || low.includes('shop all products')) return 'Shop All Products';
    if (low.includes('ติดต่อผ่าน line') || low.includes('line')) return 'Chat via LINE';
    if (low.includes('ติดต่อผ่าน facebook') || low.includes('facebook')) return 'Chat via Facebook';
    if (low.includes('คำถามที่พบบ่อย') || low.includes('faq')) return 'FAQs';

    return str;
  };

  /* ══════════════════════════════════════════════════════════
     2. CONSTANTS
     ══════════════════════════════════════════════════════════ */
  const SESSION_KEY   = 'kma_chat_state_v1';
  const CACHE_KEY     = 'kma_chat_cache_v1';
  const API_VERSION   = '2024-01';
  const TYPING_MS     = 60;  // ultra-fast typing duration (ms)

  /* ══════════════════════════════════════════════════════════
     3. STATE — backed by localStorage with 1-Hour Expiration
     ══════════════════════════════════════════════════════════ */
  const ONE_HOUR_MS = 60 * 60 * 1000; /* 1 ชั่วโมง */

  const State = {
    _d: null,

    _defaults() {
      return {
        isOpen:        false,
        history:       [],     // Array of node objects (navigation stack)
        greetingShown: false,
        tooltipShown:  false,
        chatHtml:      '',     // Full chat conversation DOM HTML
        locale:        currentLocale,
        lastActive:    Date.now()
      };
    },

    load() {
      try {
        const raw = localStorage.getItem(SESSION_KEY) || sessionStorage.getItem(SESSION_KEY);
        if (raw) {
          const parsed = JSON.parse(raw);
          const now = Date.now();
          /* ตรวจสอบว่าเปลี่ยนภาษาหรือไม่ หรือประวัติเดิมไม่มี locale หรือหมดอายุ 1 ชม. */
          const isLocaleChanged = !parsed.locale || (parsed.locale !== currentLocale);
          if (isLocaleChanged) {
            console.log('[KMA Chat] สลับภาษา (' + (parsed.locale || 'legacy') + ' -> ' + currentLocale + ') -> เริ่มต้นแชทภาษาใหม่');
            this._d = this._defaults();
            this._save();
          } else if (parsed.lastActive && (now - parsed.lastActive > ONE_HOUR_MS)) {
            console.log('[KMA Chat] หมดเวลา Session 1 ชม. -> ล้างประวัติแชทเริ่มต้นใหม่');
            this._d = this._defaults();
            this._save();
          } else {
            this._d = Object.assign(this._defaults(), parsed);
            this._d.locale = currentLocale;
            this.touch();
          }
        } else {
          this._d = this._defaults();
        }
      } catch (_) {
        this._d = this._defaults();
      }
      return this;
    },

    _save() {
      try {
        const dataStr = JSON.stringify(this._d);
        localStorage.setItem(SESSION_KEY, dataStr);
        sessionStorage.setItem(SESSION_KEY, dataStr);
      } catch (_) {}
    },

    touch() {
      if (!this._d) return;
      this._d.lastActive = Date.now();
      this._save();
    },

    get(key)        { return this._d ? this._d[key] : null; },
    set(key, val)   { if (this._d) { this._d[key] = val; this.touch(); } },

    saveChatHtml(html) {
      if (this._d) {
        this._d.chatHtml = html;
        this.touch();
      }
    },

    pushHistory(node) {
      if (this._d) {
        this._d.history.push(node);
        this.touch();
      }
    },

    popHistory() {
      if (!this._d) return null;
      const node = this._d.history.pop();
      this.touch();
      return node;
    },

    clearHistory() {
      if (this._d) {
        this._d.history = [];
        this._d.chatHtml = '';
        this._d.greetingShown = false;
        this.touch();
      }
    }
  };

  /* ══════════════════════════════════════════════════════════
     4. ANALYTICS — GA4 / GTM dataLayer
     ══════════════════════════════════════════════════════════ */
  const Analytics = {
    push(event, data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event }, data || {}));
    },
    open()                          { this.push('kma_chat_open'); },
    close()                         { this.push('kma_chat_close'); },
    mainMenu()                      { this.push('kma_chat_main_menu'); },
    clickNewArrival()               { this.push('kma_chat_click_new_arrival'); },
    clickPromotion()                { this.push('kma_chat_click_promotion'); },
    clickAdvisor()                  { this.push('kma_chat_click_product_advisor'); },
    clickTracking()                 { this.push('kma_chat_click_tracking'); },
    clickSupport()                  { this.push('kma_chat_click_support'); },
    categorySelect(category)        { this.push('kma_chat_category_select', { category }); },
    advisorAnswer(answer)           { this.push('kma_chat_advisor_answer', { answer }); },
    productClick(id, name, source)  { this.push('kma_chat_product_click', { product_id: id, product_name: name, source }); },
    promotionClick(campaign_name)   { this.push('kma_chat_promotion_click', { campaign_name }); },
    supportClick(topic)             { this.push('kma_chat_support_click', { topic }); },
    back()                          { this.push('kma_chat_back'); },
    returnHome()                    { this.push('kma_chat_return_home'); }
  };

  /* ══════════════════════════════════════════════════════════
     5. API — Shopify Storefront GraphQL + Product AJAX
     ══════════════════════════════════════════════════════════ */
  const API = {
    _cache: {},

    loadCache() {
      try {
        const raw = sessionStorage.getItem(CACHE_KEY);
        if (raw) this._cache = JSON.parse(raw);
      } catch (_) {}
    },

    _saveCache() {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(this._cache)); } catch (_) {}
    },

    async graphql(query) {
      const token  = Config.storefrontToken;
      const domain = Config.shopDomain;

      if (!token || !domain) {
        console.warn('[KMA Chat] Storefront API token หรือ domain ไม่ได้ตั้งค่า');
        return null;
      }

      const cacheKey = btoa(unescape(encodeURIComponent(query))).substring(0, 60);
      /* ถ้าเป็น query metaobjects ให้ดึงสดเพื่อความแม่นยำ */
      const isMetaobjectQuery = query.includes('metaobjects(');
      if (!isMetaobjectQuery && this._cache[cacheKey]) return this._cache[cacheKey];

      try {
        const res = await fetch(`https://${domain}/api/${API_VERSION}/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
            'Accept-Language': 'th, th-TH;q=0.9, en;q=0.1'
          },
          body: JSON.stringify({ query })
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.errors) { console.warn('[KMA Chat] GraphQL errors:', json.errors); }
        const data = json.data || null;
        if (data) { this._cache[cacheKey] = data; this._saveCache(); }
        return data;
      } catch (err) {
        console.error('[KMA Chat] API error:', err);
        return null;
      }
    },

    /* ── Shared product fragment ── */
    _productFragment: `
      fragment ProductFields on Product {
        handle
        title
        description
        onlineStoreUrl
        availableForSale
        priceRange { minVariantPrice { amount currencyCode } }
        compareAtPriceRange { minVariantPrice { amount currencyCode } }
        featuredImage { url(transform: {maxWidth: 600, crop: CENTER}) altText }
      }
    `,

    /* ── Shared media fragment ── */
    _mediaFragment: `
      fragment MediaFields on MediaImage {
        image { url(transform: {maxWidth: 800}) altText }
      }
    `,

    async getMenuNodes() {
      const data = await this.graphql(`
        { metaobjects(type: "kma_chat_menu", first: 100) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on Metaobject { id handle }
                  ... on MediaImage { image { url altText } }
                }
              }
            }
          }
        }
      `);
      return data?.metaobjects?.nodes || [];
    },

    async getResponses() {
      const data = await this.graphql(`
        { metaobjects(type: "kma_chat_content", first: 100) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on Metaobject { id handle }
                  ... on MediaImage { image { url(transform:{maxWidth:800}) altText } }
                  ... on Product {
                    handle title description onlineStoreUrl availableForSale
                    priceRange { minVariantPrice { amount currencyCode } }
                    compareAtPriceRange { minVariantPrice { amount currencyCode } }
                    featuredImage { url(transform:{maxWidth:600,crop:CENTER}) altText }
                  }
                  ... on Collection {
                    handle title onlineStoreUrl
                    products(first: 24) {
                      nodes {
                        handle title description onlineStoreUrl availableForSale
                        priceRange { minVariantPrice { amount currencyCode } }
                        compareAtPriceRange { minVariantPrice { amount currencyCode } }
                        featuredImage { url(transform:{maxWidth:600,crop:CENTER}) altText }
                      }
                    }
                  }
                }
                references(first: 30) {
                  nodes {
                    __typename
                    ... on Metaobject {
                      id handle
                      fields {
                        key value type
                        reference {
                          __typename
                          ... on MediaImage { image { url(transform:{maxWidth:600,crop:CENTER}) altText } }
                          ... on Product { handle description }
                          ... on Collection { handle }
                        }
                      }
                    }
                    ... on Product {
                      handle title description onlineStoreUrl availableForSale
                      priceRange { minVariantPrice { amount currencyCode } }
                      compareAtPriceRange { minVariantPrice { amount currencyCode } }
                      featuredImage { url(transform:{maxWidth:600,crop:CENTER}) altText }
                    }
                  }
                }
              }
            }
          }
        }
      `);
      return data?.metaobjects?.nodes || [];
    },

    async getCards() {
      const data = await this.graphql(`
        { metaobjects(type: "kma_chat_card", first: 100) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on MediaImage { image { url(transform:{maxWidth:600,crop:CENTER}) altText } }
                  ... on Product {
                    handle title onlineStoreUrl availableForSale
                    priceRange { minVariantPrice { amount currencyCode } }
                    compareAtPriceRange { minVariantPrice { amount currencyCode } }
                    featuredImage { url(transform:{maxWidth:600,crop:CENTER}) altText }
                  }
                  ... on Collection { handle title onlineStoreUrl }
                }
              }
            }
          }
        }
      `);
      return data?.metaobjects?.nodes || [];
    },

    async getAdvisorNodes() {
      /* รองรับ type kma_product_advisor และ kma_chat_advisor_node */
      const data = await this.graphql(`
        { metaobjects(type: "kma_product_advisor", first: 200) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on Metaobject { id handle }
                }
                references(first: 20) {
                  nodes {
                    __typename
                    ... on Metaobject { id handle }
                    ... on Product {
                      handle title onlineStoreUrl availableForSale
                      priceRange { minVariantPrice { amount currencyCode } }
                      compareAtPriceRange { minVariantPrice { amount currencyCode } }
                      featuredImage { url(transform:{maxWidth:600,crop:CENTER}) altText }
                    }
                  }
                }
              }
            }
          }
        }
      `);
      if (data?.metaobjects?.nodes?.length) return data.metaobjects.nodes;

      const dataFallback = await this.graphql(`
        { metaobjects(type: "kma_chat_advisor_node", first: 200) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on Metaobject { id handle }
                }
                references(first: 20) {
                  nodes {
                    __typename
                    ... on Metaobject { id handle }
                    ... on Product {
                      handle title onlineStoreUrl availableForSale
                      priceRange { minVariantPrice { amount currencyCode } }
                      compareAtPriceRange { minVariantPrice { amount currencyCode } }
                      featuredImage { url(transform:{maxWidth:600,crop:CENTER}) altText }
                    }
                  }
                }
              }
            }
          }
        }
      `);
      return dataFallback?.metaobjects?.nodes || [];
    },

    async getSupports() {
      /* รองรับ type ทั้ง kma_support และ kma_chat_support */
      const data = await this.graphql(`
        { metaobjects(type: "kma_support", first: 50) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on Metaobject { id handle }
                  ... on MediaImage { image { url(transform:{maxWidth:800}) altText } }
                }
                references(first: 10) {
                  nodes {
                    __typename
                    ... on Metaobject { id handle }
                  }
                }
              }
            }
          }
        }
      `);
      if (data?.metaobjects?.nodes?.length) return data.metaobjects.nodes;

      /* Fallback query kma_chat_support */
      const dataFallback = await this.graphql(`
        { metaobjects(type: "kma_chat_support", first: 50) {
            nodes {
              id handle
              fields {
                key value type
                reference {
                  __typename
                  ... on Metaobject { id handle }
                  ... on MediaImage { image { url(transform:{maxWidth:800}) altText } }
                }
              }
            }
          }
        }
      `);
      return dataFallback?.metaobjects?.nodes || [];
    },

    /* ── Store Locations (ดึงข้อมูลสาขาจาก store_location ทั้งหมด) ── */
    async getStoreLocations() {
      const data = await this.graphql(`
        { metaobjects(type: "store_location", first: 250) {
            nodes {
              id handle
              fields {
                key value type
              }
            }
          }
        }
      `);
      return data?.metaobjects?.nodes || [];
    },

    /* ── Product AJAX (ไม่ต้องใช้ token) ── */
    async getProduct(handle) {
      const key = 'prod_' + handle;
      if (this._cache[key]) return this._cache[key];
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const p = await res.json();
        this._cache[key] = p;
        this._saveCache();
        return p;
      } catch (err) {
        console.error('[KMA Chat] Product fetch:', err);
        return null;
      }
    },

    /* ── Collection Products (ดึงสินค้าใน Collection ภาษาไทย 100%) ── */
    async getCollectionProducts(handle) {
      const key = 'coll_th_' + handle;
      if (this._cache[key]) return this._cache[key];

      /* 1. ลองดึงผ่าน GraphQL ด้วยภาษาไทย (@inContext(language: TH)) ก่อน */
      try {
        const gqlData = await this.graphql(`
          query getCollectionThaiProducts @inContext(language: TH) {
            collection(handle: "${handle}") {
              products(first: 24) {
                nodes {
                  id
                  handle
                  title
                  description
                  availableForSale
                  priceRange { minVariantPrice { amount currencyCode } }
                  compareAtPriceRange { minVariantPrice { amount currencyCode } }
                  featuredImage { url(transform: {maxWidth: 600, crop: CENTER}) altText }
                }
              }
            }
          }
        `);
        const gqlProds = gqlData?.collection?.products?.nodes;
        if (gqlProds && gqlProds.length) {
          this._cache[key] = gqlProds;
          this._saveCache();
          return gqlProds;
        }
      } catch (gqlErr) {
        console.warn('[KMA Chat] GraphQL Thai collection fetch fallback:', gqlErr);
      }

      /* 2. Fallback AJAX fetch */
      try {
        const res = await fetch(`/collections/${handle}/products.json`, {
          headers: { 'Accept-Language': 'th, th-TH;q=0.9' }
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        const products = data.products || [];
        this._cache[key] = products;
        this._saveCache();
        return products;
      } catch (err) {
        console.error('[KMA Chat] Collection products fetch:', err);
        return [];
      }
    }
  };

  /* ══════════════════════════════════════════════════════════
     6. DATA HELPER — แปลง Metaobject fields เป็น plain object
     ══════════════════════════════════════════════════════════ */
  const DataHelper = {
    /* แปลง fields array เป็น {key: value} */
    parseFields(node) {
      const obj = { id: node.id, handle: node.handle };
      for (const f of (node.fields || [])) {
        const k = f.key;
        if (f.references && Array.isArray(f.references.nodes)) {
          obj[k] = f.references.nodes;
        } else if (f.reference) {
          obj[k] = f.reference;
        } else {
          switch (f.type) {
            case 'boolean':
              obj[k] = f.value === 'true';
              break;
            case 'number_integer':
            case 'number_decimal':
              obj[k] = parseFloat(f.value) || 0;
              break;
            case 'date_time':
            case 'date':
              obj[k] = f.value ? new Date(f.value) : null;
              break;
            default:
              obj[k] = f.value || '';
          }
        }
      }
      
      /* Fallback title / label */
      if (!obj.title) {
        obj.title = obj.menu_name || obj.name || obj.display_name || obj.answer_label || obj.node_title || '';
      }

      /* ── Dynamic Field Mapping สำหรับโครงสร้าง KMA Chat Content จริง ── */
      if (obj.content_type) {
        obj.response_type = obj.content_type;
      }
      if (obj.cards || obj.mycards || obj.card) {
        const rawCards = obj.cards || obj.mycards || obj.card;
        obj.related_cards = Array.isArray(rawCards) ? rawCards : [rawCards];
      }
      if (obj.products || obj.product) {
        const rawProds = obj.products || obj.product;
        obj.related_products = Array.isArray(rawProds) ? rawProds : [rawProds];
      }
      
      /* ถ้า content_type เป็น collection หรือ product_carousel ให้ตั้ง response_type เสมอ */
      if (obj.content_type === 'collection' || obj.content_type === 'product_carousel') {
        obj.response_type = 'product_carousel';
      }

      /* พยายามดึงสินค้าจาก collection.products.nodes (ถ้า GraphQL ส่งมา) */
      if (obj.collection && obj.collection.products && Array.isArray(obj.collection.products.nodes) && obj.collection.products.nodes.length) {
        let limit = parseInt(obj.product_limit, 10) || 8;
        obj.related_products = obj.collection.products.nodes.slice(0, limit);
      }
      
      return obj;
    },

    /* ตรวจสอบ active + date range */
    isActive(item) {
      if (item.active === false) return false;
      if (item.start_date instanceof Date && !isNaN(item.start_date) && new Date() < item.start_date) return false;
      if (item.end_date   instanceof Date && !isNaN(item.end_date)   && new Date() > item.end_date)   return false;
      return true;
    },

    sortItems(items) {
      return [...items].sort((a, b) => ((a.sort_order || 0) - (b.sort_order || 0)));
    },

    /* แปลงราคาเป็น Thai format */
    formatPrice(amount, currency) {
      const num = parseFloat(amount);
      if (isNaN(num)) return '';
      if (currency === 'THB' || !currency) return '฿' + Math.round(num).toLocaleString('th-TH');
      return currency + ' ' + num.toLocaleString();
    },

    /* สร้าง product card data object จาก Storefront API format */
    normalizeProduct(p) {
      if (!p) return null;
      
      /* ดึงราคาเริ่มต้น */
      let priceAmt = '';
      if (p.priceRange?.minVariantPrice) {
        priceAmt = this.formatPrice(p.priceRange.minVariantPrice.amount, p.priceRange.minVariantPrice.currencyCode);
      } else if (p.variants && p.variants[0]) {
        priceAmt = this.formatPrice(p.variants[0].price, Config.currency || 'THB');
      } else if (p.price) {
        priceAmt = '฿' + Math.round(p.price / 100).toLocaleString('th-TH');
      }
      
      /* ดึงราคาเปรียบเทียบ */
      let compareAmt = '';
      if (p.compareAtPriceRange?.minVariantPrice) {
        compareAmt = this.formatPrice(p.compareAtPriceRange.minVariantPrice.amount, p.compareAtPriceRange.minVariantPrice.currencyCode);
      } else if (p.variants && p.variants[0] && p.variants[0].compare_at_price) {
        compareAmt = this.formatPrice(p.variants[0].compare_at_price, Config.currency || 'THB');
      } else if (p.compare_at_price && p.compare_at_price > p.price) {
        compareAmt = '฿' + Math.round(p.compare_at_price / 100).toLocaleString('th-TH');
      }

      /* ดึงลิงก์รูปภาพ */
      let imgUrl = '';
      if (p.featuredImage?.url) {
        imgUrl = p.featuredImage.url;
      } else if (p.images && p.images[0]) {
        imgUrl = p.images[0].src || p.images[0];
      } else if (p.featured_image) {
        imgUrl = p.featured_image;
      }

      /* ดึง Alt รูปภาพ */
      let imgAlt = p.featuredImage?.altText || p.title || '';
      
      /* ดึงและทำความสะอาด Description (ตัด HTML tags ออก) */
      let rawDesc = p.description || p.body_html || p.descriptionHtml || p.summary || '';
      if (typeof rawDesc === 'string') {
        rawDesc = rawDesc.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
      }

      /* URL สินค้าเวอร์ชันภาษาไทยมาตรฐาน (ตัด /en/ ออก) */
      let prodUrl = p.onlineStoreUrl || `/products/${p.handle}`;
      if (prodUrl.includes('/en/products/')) {
        prodUrl = prodUrl.replace('/en/products/', '/products/');
      } else if (prodUrl.startsWith('/en/')) {
        prodUrl = prodUrl.replace('/en/', '/');
      }
      
      return {
        handle:        p.handle,
        id:            p.id || p.handle,
        title:         p.title,
        description:   rawDesc,
        url:           prodUrl,
        available:     p.availableForSale !== false && p.available !== false,
        imageUrl:      imgUrl,
        imageAlt:      imgAlt,
        priceStr:      priceAmt,
        compareStr:    compareAmt
      };
    }
  };

  /* ══════════════════════════════════════════════════════════
     7. RENDERER — สร้าง DOM elements สำหรับทุก message type
     ══════════════════════════════════════════════════════════ */
  const Renderer = {
    get _msg() { return document.getElementById('kma-chat-messages'); },

    /* ── Escape helpers ── */
    _esc(s) {
      if (!s) return '';
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    },
    _escAttr(s) {
      if (!s) return '';
      return String(s).replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    },

    /* ── Scroll & Auto-Save History ── */
    scrollToBottom() {
      const m = this._msg;
      if (!m) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) { m.scrollTop = m.scrollHeight; }
      else         { m.scrollTo({ top: m.scrollHeight, behavior: 'smooth' }); }

      /* Auto-save full chat conversation HTML for 1-hour session persistence */
      if (m.innerHTML.trim().length > 0) {
        State.saveChatHtml(m.innerHTML);
      }
    },

    clearMessages() {
      if (this._msg) this._msg.innerHTML = '';
      State.saveChatHtml('');
    },

    restoreMessages(html) {
      if (this._msg && html) {
        this._msg.innerHTML = html;
        this.scrollToBottom();
      }
    },

    /* ── Time helper ── */
    _getCurrentTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const mins = String(now.getMinutes()).padStart(2, '0');
      return `${hours}:${mins}`;
    },

    /* ── Bot bubble ── */
    addBotBubble(text, showMeta = true) {
      const m = this._msg; if (!m) return null;
      const wrap = document.createElement('div');
      wrap.className = 'kma-chat-msg-wrap kma-chat-msg-wrap--bot';

      const div = document.createElement('div');
      div.className = 'kma-chat-bubble kma-chat-bubble--bot';
      div.innerHTML  = `<p>${this._esc(text).replace(/\\n|\n/g, '<br>')}</p>`;
      wrap.appendChild(div);

      if (showMeta) {
        const meta = document.createElement('div');
        meta.className = 'kma-chat-meta';
        meta.textContent = `KMA Cosmetics · ${this._getCurrentTime()}`;
        wrap.appendChild(meta);
      }

      m.appendChild(wrap);
      this.scrollToBottom();
      return wrap;
    },

    /* ── Welcome Card (NYX-Style Hero Banner) ── */
    addWelcomeCard(cardData, onAction) {
      const m = this._msg; if (!m) return null;
      const wrap = document.createElement('div');
      wrap.className = 'kma-chat-msg-wrap kma-chat-welcome-card-wrap';

      const card = document.createElement('div');
      card.className = 'kma-chat-welcome-card';

      const imgUrl = cardData.image_url || cardData.image?.url || cardData.image?.image?.url || '';
      const imgAlt = cardData.image_alt || 'KMA Cosmetics';
      const ctaLabel = cardData.cta_label || 'Message Us';
      const clickUrl = cardData.url || cardData.cta_url || '';

      let imgHtml = '';
      if (imgUrl) {
        if (clickUrl) {
          imgHtml = `<a href="${this._escAttr(clickUrl)}" class="kma-chat-welcome-card__img-link" target="_blank" rel="noopener noreferrer">
            <img src="${this._escAttr(imgUrl)}" alt="${this._escAttr(imgAlt)}" class="kma-chat-welcome-card__img" loading="lazy">
          </a>`;
        } else {
          imgHtml = `<div class="kma-chat-welcome-card__img-wrap">
            <img src="${this._escAttr(imgUrl)}" alt="${this._escAttr(imgAlt)}" class="kma-chat-welcome-card__img" loading="lazy">
          </div>`;
        }
      }

      card.innerHTML = `
        ${imgHtml}
        <div class="kma-chat-welcome-card__body">
          <button type="button" class="kma-chat-welcome-card__btn">${this._esc(ctaLabel)}</button>
        </div>
      `;

      card.querySelector('.kma-chat-welcome-card__btn')?.addEventListener('click', () => {
        if (onAction) onAction();
      });

      wrap.appendChild(card);
      m.appendChild(wrap);
      this.scrollToBottom();
      return wrap;
    },

    /* ── User bubble ── */
    addUserBubble(text) {
      const m = this._msg; if (!m) return null;
      const wrap = document.createElement('div');
      wrap.className = 'kma-chat-msg-wrap kma-chat-msg-wrap--user';

      const div = document.createElement('div');
      div.className = 'kma-chat-bubble kma-chat-bubble--user';
      div.innerHTML  = `<p>${this._esc(text)}</p>`;
      wrap.appendChild(div);

      m.appendChild(wrap);
      this.scrollToBottom();
      return wrap;
    },

    /* ── Typing indicator ── */
    addTypingIndicator() {
      const m = this._msg; if (!m) return null;
      const div = document.createElement('div');
      div.className = 'kma-chat-bubble kma-chat-bubble--bot kma-typing-bubble';
      div.innerHTML  = '<div class="kma-typing"><span></span><span></span><span></span></div>';
      m.appendChild(div);
      this.scrollToBottom();
      return div;
    },

    removeTypingIndicator(el) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    },

    /* ── Menu buttons (Chips / Pill style) ── */
    addMenuButtons(items, onSelect, alignCenter) {
      const m = this._msg; if (!m) return null;
      const wrapper = document.createElement('div');
      wrapper.className = 'kma-chat-menu' + (alignCenter || items.length === 1 ? ' kma-chat-menu--center' : '');
      wrapper.setAttribute('role', 'group');
      wrapper.setAttribute('aria-label', 'เลือกเมนู');

      items.forEach(item => {
        const rawLabel = item.title || item.answer_label || item.node_title || '';
        /* ล้างอิโมจิออกจากข้อความปุ่ม 100% */
        const cleanLabel = rawLabel
          .replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}📍✨🎁💄📦💬🛍️❓👥📍]/gu, '')
          .trim();

        const localizedLabel = isEn ? localizeText(cleanLabel || rawLabel, item.handle, item.action_type) : (cleanLabel || rawLabel);
        const queryVal = item.query || item.title || cleanLabel || rawLabel;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kma-chat-menu__btn';
        btn.setAttribute('data-kma-query', queryVal);
        btn.setAttribute('data-kma-title', rawLabel);
        btn.innerHTML = `<span class="kma-chat-menu__label">${this._esc(localizedLabel)}</span>`;
        btn.addEventListener('click', () => {
          /* disable all siblings */
          wrapper.querySelectorAll('.kma-chat-menu__btn').forEach(b => {
            b.disabled = true;
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          onSelect(item);
        });
        wrapper.appendChild(btn);
      });

      m.appendChild(wrapper);
      this.scrollToBottom();
      return wrapper;
    },

    /* ── Image message ── */
    addImage(url, alt) {
      const m = this._msg; if (!m) return null;
      const wrap = document.createElement('div');
      wrap.className = 'kma-chat-image-wrap';
      wrap.innerHTML = `<img src="${this._escAttr(url)}" alt="${this._escAttr(alt)}" class="kma-chat-image" loading="lazy">`;
      m.appendChild(wrap);
      this.scrollToBottom();
      return wrap;
    },

    /* ── Generic card ── */
    addCard(card) {
      const m = this._msg; if (!m) return null;
      const div = document.createElement('div');
      div.className = 'kma-chat-card';
      const imgUrl = card.image?.url || card.image?.image?.url || '';
      const imgAlt = card.image_alt || card.image?.altText || card.title || '';
      const ctaUrl = card.cta_url || '#';
      const isExt  = ctaUrl.startsWith('http') && !ctaUrl.includes(Config.shopDomain || '');
      div.innerHTML = `
        ${imgUrl ? `<div class="kma-chat-card__image-wrap"><img src="${this._escAttr(imgUrl)}" alt="${this._escAttr(imgAlt)}" class="kma-chat-card__image" loading="lazy"></div>` : ''}
        <div class="kma-chat-card__body">
          ${card.title       ? `<p class="kma-chat-card__title">${this._esc(card.title)}</p>` : ''}
          ${card.description ? `<p class="kma-chat-card__desc">${this._esc(card.description)}</p>` : ''}
          ${card.cta_label   ? `<a href="${this._escAttr(ctaUrl)}" class="kma-chat-cta" ${isExt ? 'target="_blank" rel="noopener noreferrer"' : ''}>${this._esc(card.cta_label)}</a>` : ''}
        </div>`;
      m.appendChild(div);
      this.scrollToBottom();
      return div;
    },

    /* ── Product card ── */
    addProductCard(product, source) {
      const m = this._msg; if (!m) return null;
      const p   = DataHelper.normalizeProduct(product);
      if (!p) return null;
      const div = this._buildProductCardEl(p, source || 'chat');
      m.appendChild(div);
      this.scrollToBottom();
      return div;
    },

    /* shared builder for product card DOM */
    _buildProductCardEl(p, source) {
      const div = document.createElement('div');
      div.className = 'kma-chat-product-card';
      let prodUrl = p.url || '';
      if (isEn && prodUrl.startsWith('/products/') && !prodUrl.startsWith('/en/')) {
        prodUrl = '/en' + prodUrl;
      }
      const ctaText = isEn ? 'View Product' : 'ดูรายละเอียดสินค้า';
      const soldOutText = isEn ? 'Sold Out' : 'สินค้าหมดชั่วคราว';

      div.innerHTML = `
        <div class="kma-chat-product-card__image-wrap">
          ${p.imageUrl ? `<img src="${this._escAttr(p.imageUrl)}" alt="${this._escAttr(p.imageAlt)}" class="kma-chat-product-card__image" loading="lazy">` : '<div class="kma-chat-product-card__placeholder"></div>'}
          ${!p.available ? `<span class="kma-chat-product-card__sold-out">${soldOutText}</span>` : ''}
        </div>
        <div class="kma-chat-product-card__body">
          <p class="kma-chat-product-card__title">${this._esc(p.title)}</p>
          ${p.description ? `<p class="kma-chat-product-card__desc">${this._esc(p.description)}</p>` : ''}
          <div class="kma-chat-product-card__price">
            ${p.priceStr   ? `<span class="kma-chat-product-card__price--current">${this._esc(p.priceStr)}</span>` : ''}
            ${p.compareStr ? `<s class="kma-chat-product-card__price--compare">${this._esc(p.compareStr)}</s>` : ''}
          </div>
          <a href="${this._escAttr(prodUrl)}" class="kma-chat-cta kma-chat-cta--product"
             data-product-id="${this._escAttr(String(p.id || p.handle))}"
             data-product-name="${this._escAttr(p.title)}"
             data-source="${this._escAttr(source)}">
            ${ctaText}
          </a>
        </div>`;
      div.querySelector('.kma-chat-cta--product')?.addEventListener('click', () => {
        Analytics.productClick(p.id || p.handle, p.title, source);
      });
      return div;
    },

    /* ── Store Search Input Box ── */
    

    /* ── Store Cards List (Compact Row Item matching Google Maps / Apple Maps style) ── */
    addStoreCardsList(stores, totalCount, onMore, filterContext) {
      const m = this._msg; if (!m || !stores.length) return null;
      const wrap = document.createElement('div');
      wrap.className = 'kma-chat-store-list';

      const configLogos = Config.brandLogos || {};

      /* Map สี & Logo รูปภาพของแต่ละ Brand Group พร้อม Fallback ป้องกันรูปแตก 100% */
      const getBrandMeta = (group) => {
        const g = (group || '').toUpperCase();
        if (g.includes('BEAUTRIUM')) return { img: configLogos.beautrium, label: 'BT', bg: '#ED1C24', color: '#FFFFFF', full: 'BEAUTRIUM' };
        if (g.includes('EVEANDBOY')) return { img: configLogos.eveandboy, label: 'EB', bg: '#E4007F', color: '#FFFFFF', full: 'EVEANDBOY' };
        if (g.includes('MULTY'))     return { img: configLogos.multy, label: 'ML', bg: '#F26522', color: '#FFFFFF', full: 'MULTY' };
        if (g.includes('KIS'))       return { img: configLogos.kis, label: 'KIS', bg: '#F8A5C2', color: '#000000', full: 'KIS' };
        if (g.includes('LOTUS'))     return { img: configLogos.lotus, label: 'LT', bg: '#00A499', color: '#FFFFFF', full: 'LOTUS' };
        if (g.includes('ROBINSON'))  return { img: configLogos.robinson, label: 'RB', bg: '#00AA4F', color: '#FFFFFF', full: 'ROBINSON' };
        if (g.includes('TSURUHA'))   return { img: configLogos.tsuruha, label: 'TS', bg: '#EE1C25', color: '#FFFFFF', full: 'TSURUHA' };
        return { img: null, label: 'KMA', bg: '#FAF0EB', color: 'var(--kma-primary)', full: group || 'KMA STORE' };
      };

      stores.forEach(s => {
        const card = document.createElement('div');
        card.className = 'kma-chat-store-row';

        const mapUrl = s.store_url || (s.latitude && s.longitude ? `https://www.google.com/maps/search/?api=1&query=${s.latitude},${s.longitude}` : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s.store_name + ' ' + (s.province || '') + ' ' + (s.address || ''))}`);
        const brand = getBrandMeta(s.store_group);

        /* จัดข้อความบรรทัดย่อย (เช่น BEAUTRIUM • ชั้น 1 หรือ ระยะทาง) */
        const subDetails = [
          s.store_group ? brand.full : null,
          s.floor ? s.floor : null
        ].filter(Boolean).join(' • ');

        const avatarBg = brand.img ? '#FFFFFF' : brand.bg;
        const avatarColor = brand.img ? 'inherit' : brand.color;
        
        /* ใส่ onerror handler เพื่อป้องกัน icon รูปภาพแตกอย่างสมบูรณ์ */
        const avatarHtml = brand.img 
          ? `<img src="${this._escAttr(brand.img)}" alt="${this._escAttr(brand.full)}" class="kma-chat-store-row__img" loading="lazy" onerror="this.onerror=null; this.style.display='none'; this.parentElement.style.background='${brand.bg}'; this.parentElement.innerHTML='<span style=\\'color:${brand.color};font-weight:800;font-size:13px;\\'>${brand.label}</span>';" />`
          : `<span>${brand.label}</span>`;

        card.innerHTML = `
          <div class="kma-chat-store-row__avatar" style="background:${avatarBg}; color:${avatarColor};">
            ${avatarHtml}
          </div>
          <div class="kma-chat-store-row__info">
            <h4 class="kma-chat-store-row__title">${this._esc(s.store_name)}</h4>
            <p class="kma-chat-store-row__subtitle">${this._esc(subDetails || 'จุดจำหน่าย KMA')}</p>
          </div>
          <a href="${this._escAttr(mapUrl)}" target="_blank" rel="noopener noreferrer" class="kma-chat-store-row__nav-btn" aria-label="นำทางไปยัง ${this._escAttr(s.store_name)}">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
            </svg>
          </a>
        `;
        wrap.appendChild(card);
      });

      if (totalCount > stores.length) {
        const moreLink = document.createElement('a');
        const searchParam = filterContext ? `?q=${encodeURIComponent(filterContext)}&province=${encodeURIComponent(filterContext)}` : '';
        moreLink.href = `https://kmacosme.com/pages/kma-stores${searchParam}`;
        moreLink.target = '_blank';
        moreLink.rel = 'noopener noreferrer';
        moreLink.className = 'kma-chat-store-more-btn';
        moreLink.innerHTML = `
          <span>ดูจุดจำหน่ายทั้งหมด (${totalCount} สาขา)</span>
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4l6 6-6 6"/></svg>
        `;
        wrap.appendChild(moreLink);
      }

      m.appendChild(wrap);
      this.scrollToBottom();
      return wrap;
    },

    /* ── Carousel ── */
    addCarousel(items, renderItemFn) {
      const m = this._msg; if (!m || !items.length) return null;
      const wrapper  = document.createElement('div');
      wrapper.className = 'kma-carousel-wrapper';
      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'kma-carousel__arrow kma-carousel__arrow--prev';
      prevBtn.setAttribute('aria-label', 'ดูการ์ดก่อนหน้า');
      prevBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M13 16L7 10l6-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'kma-carousel__arrow kma-carousel__arrow--next';
      nextBtn.setAttribute('aria-label', 'ดูการ์ดถัดไป');
      nextBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7 4l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const track = document.createElement('div');
      track.className = 'kma-carousel';
      track.setAttribute('role', 'list');
      items.forEach(item => {
        const slide = document.createElement('div');
        slide.className = 'kma-carousel__slide';
        slide.setAttribute('role', 'listitem');
        const el = renderItemFn(item);
        if (el) slide.appendChild(el);
        track.appendChild(slide);
      });
      wrapper.appendChild(prevBtn);
      wrapper.appendChild(track);
      wrapper.appendChild(nextBtn);
      m.appendChild(wrapper);
      Carousel.init(track, prevBtn, nextBtn);
      this.scrollToBottom();
      return wrapper;
    },

    /* ── Link button (NYX Auto-Width Choice Chip Style — 100% No Emojis / No Arrows) ── */
    addLinkButton(label, url, isExternal, onClick) {
      const m = this._msg; if (!m) return null;
      
      /* ดึงหรือสร้าง link-wrap ล่าสุดเพื่อเรียงต่อกันจากขวาไปซ้าย */
      let wrap = m.lastElementChild;
      if (!wrap || !wrap.classList.contains('kma-chat-link-wrap')) {
        wrap = document.createElement('div');
        wrap.className = 'kma-chat-link-wrap';
        m.appendChild(wrap);
      }

      /* ล้างอิโมจิและเครื่องหมายลูกศรทั้งหมดออก 100% */
      const cleanText = (label || '')
        .replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}]/gu, '')
        .replace(/[›>‹<]/g, '')
        .trim();

      const a = document.createElement('a');
      a.href = url;
      a.className = 'kma-chat-cta';
      a.textContent = cleanText;

      if (isExternal) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
      if (onClick)    a.addEventListener('click', onClick);
      wrap.appendChild(a);
      this.scrollToBottom();
      return wrap;
    },

    /* ── Empty state ── */
    addEmptyState(message, onHome) {
      const m = this._msg; if (!m) return null;
      const div = document.createElement('div');
      div.className = 'kma-chat-empty';
      div.innerHTML = `
        <p class="kma-chat-empty__text">${this._esc(message)}</p>
        <button type="button" class="kma-chat-cta kma-chat-cta--secondary kma-js-home-btn">⌂ กลับเมนูหลัก</button>`;
      div.querySelector('.kma-js-home-btn')?.addEventListener('click', onHome);
      m.appendChild(div);
      this.scrollToBottom();
      return div;
    },

    /* ── Error state ── */
    addErrorState(onRetry, onHome) {
      const m = this._msg; if (!m) return null;
      const div = document.createElement('div');
      div.className = 'kma-chat-error';
      div.innerHTML = `
        <p class="kma-chat-error__text">ขออภัย ไม่สามารถโหลดข้อมูลได้ในขณะนี้<br>กรุณาลองใหม่อีกครั้งค่ะ</p>
        <div class="kma-chat-error__actions">
          <button type="button" class="kma-chat-cta kma-js-retry-btn">ลองอีกครั้ง</button>
          <button type="button" class="kma-chat-cta kma-chat-cta--secondary kma-js-home-btn">⌂ กลับเมนูหลัก</button>
        </div>`;
      div.querySelector('.kma-js-retry-btn')?.addEventListener('click', onRetry);
      div.querySelector('.kma-js-home-btn')?.addEventListener('click', onHome);
      m.appendChild(div);
      this.scrollToBottom();
      return div;
    }
  };

  /* ══════════════════════════════════════════════════════════
     8. CAROUSEL — Touch · Mouse drag · Arrow navigation · Snap
     ══════════════════════════════════════════════════════════ */
  const Carousel = {
    init(track, prevBtn, nextBtn) {
      let startX   = 0;
      let startScroll = 0;
      let isDragging  = false;

      /* Mouse drag on Desktop only */
      track.addEventListener('mousedown', e => {
        isDragging  = true;
        startX      = e.clientX;
        startScroll = track.scrollLeft;
        track.style.cursor      = 'grabbing';
        track.style.userSelect  = 'none';
      });
      document.addEventListener('mousemove', e => {
        if (!isDragging) return;
        track.scrollLeft = startScroll + (startX - e.clientX);
      });
      document.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.cursor     = '';
        track.style.userSelect = '';
      });

      /* Arrows */
      const slideW = () => {
        const s = track.querySelector('.kma-carousel__slide');
        if (!s) return 200;
        const gap = parseInt(getComputedStyle(track).gap || '10', 10);
        return s.offsetWidth + gap;
      };
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -slideW(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: slideW(), behavior: 'smooth' });
      });

      /* Update arrow state */
      const updateArrows = () => {
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      };
      track.addEventListener('scroll', updateArrows, { passive: true });
      setTimeout(updateArrows, 100);
    }
  };

  /* ══════════════════════════════════════════════════════════
     9. ACCESSIBILITY — Focus trap + keyboard navigation
     ══════════════════════════════════════════════════════════ */
  const A11y = {
    _prevFocus: null,
    _keyHandler: null,

    trapFocus(container) {
      this._prevFocus = document.activeElement;
      this._keyHandler = (e) => this._onKey(e, container);
      container.addEventListener('keydown', this._keyHandler);
      /* Move focus to close button on next tick */
      setTimeout(() => {
        const closeBtn = container.querySelector('#kma-chat-close');
        if (closeBtn) closeBtn.focus();
      }, 80);
    },

    releaseFocus(container) {
      if (container && this._keyHandler) {
        container.removeEventListener('keydown', this._keyHandler);
      }
      if (this._prevFocus && this._prevFocus.focus) {
        this._prevFocus.focus();
      }
      this._prevFocus  = null;
      this._keyHandler = null;
    },

    _onKey(e, container) {
      if (e.key === 'Escape') { Widget.close(); return; }
      if (e.key !== 'Tab') return;
      const focusable = this._getFocusable(container);
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
      }
    },

    _getFocusable(el) {
      return Array.from(el.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input:not([disabled])'
      )).filter(n => !n.closest('[hidden]') && n.offsetParent !== null);
    }
  };

  /* ══════════════════════════════════════════════════════════
     10. WIDGET — Main Orchestrator
     ══════════════════════════════════════════════════════════ */
  const Widget = {
    _menus:   [],
    _responses: [],
    _cards:   [],
    _advisors: [],
    _loaded:  false,

    async init() {
      State.load();
      API.loadCache();
      this._applyTheme();
      this._applyLocaleUI();
      this._bindEvents();
      this._setupTooltip();
      this._updateNav();

      /* Restore if was open */
      if (State.get('isOpen')) {
        await this.open({ restore: true });
      }
    },

    /* Apply Locale UI texts to static elements */
    _applyLocaleUI() {
      const toggleLabel = document.querySelector('.kma-chat-toggle__label');
      if (toggleLabel) toggleLabel.textContent = isEn ? (Config.buttonLabelEn || t('toggleLabel')) : (Config.buttonLabel || t('toggleLabel'));

      const headerTitle = document.querySelector('.kma-chat-header__title');
      if (headerTitle) headerTitle.textContent = isEn ? (Config.titleEn || t('headerTitle')) : (Config.title || t('headerTitle'));

      const headerSubtitle = document.querySelector('.kma-chat-header__subtitle');
      if (headerSubtitle) headerSubtitle.textContent = isEn ? (Config.subtitleEn || t('headerSubtitle')) : (Config.subtitle || t('headerSubtitle'));

      const homeBtnSpan = document.querySelector('#kma-chat-home span');
      if (homeBtnSpan) homeBtnSpan.textContent = t('backToMainMenu');

      const tooltipText = document.querySelector('.kma-chat-tooltip__text');
      if (tooltipText) tooltipText.textContent = isEn ? (Config.tooltipTextEn || t('tooltipText')) : (Config.tooltipText || t('tooltipText'));
    },

    /* Apply CSS custom properties from config */
    _applyTheme() {
      const r = document.documentElement.style;
      if (Config.primaryColor)        r.setProperty('--kma-primary', Config.primaryColor);
      if (Config.bottomOffsetMobile)  r.setProperty('--kma-bottom-mobile',  Config.bottomOffsetMobile  + 'px');
      if (Config.bottomOffsetDesktop) r.setProperty('--kma-bottom-desktop', Config.bottomOffsetDesktop + 'px');
    },

    _bindEvents() {
      const $ = id => document.getElementById(id);
      $('kma-chat-toggle')?.addEventListener('click', () => this.toggle());
      $('kma-chat-close')?.addEventListener('click',  () => this.close());
      $('kma-chat-back')?.addEventListener('click',   () => this.goBack());
      $('kma-chat-home')?.addEventListener('click',   () => this.goHome());
      $('kma-chat-backdrop')?.addEventListener('click', () => this.close());

      /* Click outside on desktop */
      document.addEventListener('click', e => {
        if (!State.get('isOpen') || window.innerWidth < 768) return;
        const win = $('kma-chat-window');
        const btn = $('kma-chat-toggle');
        if (win && btn && !win.contains(e.target) && !btn.contains(e.target)) {
          this.close();
        }
      });

      /* ── Setup Cart Drawer Auto-Hide Observer ── */
      this._setupCartDrawerObserver();
    },

    /* ── Auto-Hide Chat Launcher when Cart Drawer / Cart Popup opens ── */
    _setupCartDrawerObserver() {
      const btn = document.getElementById('kma-chat-toggle');
      const tooltip = document.getElementById('kma-chat-tooltip');
      if (!btn) return;

      const checkCartOpen = () => {
        /* ตรวจสอบ class หรือ attribute เมื่อเปิดตะกร้าสินค้าจริง */
        const isBodyOpen = document.body.classList.contains('cart-drawer-open') ||
                           document.body.classList.contains('cart-open') ||
                           document.body.getAttribute('data-cart-open') === 'true';

        const cartDrawerEl = document.querySelector('cart-drawer.active, cart-drawer.is-open, .cart-drawer.active, .cart-drawer.is-open, .drawer.active, .drawer.is-open, #cart-drawer.active, #CartDrawer.active');
        const isDrawerActive = !!cartDrawerEl;

        if (isBodyOpen || isDrawerActive) {
          btn.classList.add('is-hidden-by-drawer');
          tooltip?.classList.add('is-hidden-by-drawer');
        } else {
          btn.classList.remove('is-hidden-by-drawer');
          tooltip?.classList.remove('is-hidden-by-drawer');
        }
      };

      /* 1. ดักจับ DOM Mutation ของ body และ cart elements */
      const observer = new MutationObserver(checkCartOpen);
      observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'style', 'data-cart-open'] });

      /* 2. ดักจับ Custom Events ของ Shopify Theme (Dawn, Impulse, Prestige, Warehouse ฯลฯ) */
      ['cart:open', 'cart:opened', 'cart:toggle', 'cart-drawer:open', 'cart:updated', 'ajaxCart.afterCartLoad'].forEach(evtName => {
        document.addEventListener(evtName, checkCartOpen);
        window.addEventListener(evtName, checkCartOpen);
      });

      /* 3. ดักจับคลิกปุ่มปิดรถเข็น / พื้นที่รอบข้าง */
      document.addEventListener('click', () => {
        setTimeout(checkCartOpen, 100);
        setTimeout(checkCartOpen, 350);
      });
    },

    _setupTooltip() {
      if (!Config.enableTooltip) return;
      const tooltip = document.getElementById('kma-chat-tooltip');
      if (!tooltip || State.get('tooltipShown')) return;

      setTimeout(() => {
        if (State.get('isOpen')) return;
        tooltip.removeAttribute('aria-hidden');
        tooltip.classList.add('is-visible');
        State.set('tooltipShown', true);
        setTimeout(() => this._hideTooltip(), 7000);
      }, 1200);

      tooltip.querySelector('.kma-chat-tooltip__close')?.addEventListener('click', () => this._hideTooltip());
    },

    _hideTooltip() {
      const t = document.getElementById('kma-chat-tooltip');
      if (t) { t.classList.remove('is-visible'); t.setAttribute('aria-hidden', 'true'); }
    },

    /* ── Open / Close / Toggle ── */
    toggle() { State.get('isOpen') ? this.close() : this.open(); },

    /* ── Idle Timeout Management (5 Minutes) ── */
    _resetIdleTimer() {
      if (this._idleTimer) clearTimeout(this._idleTimer);
      if (!State.get('isOpen')) return;

      const TIMEOUT_MS = 5 * 60 * 1000; /* 5 นาที */
      this._idleTimer = setTimeout(() => {
        this._handleIdleTimeout();
      }, TIMEOUT_MS);
    },

    async _handleIdleTimeout() {
      if (!State.get('isOpen')) return;
      
      const timeoutMsg = t('idleTimeout');
      Renderer.addBotBubble(timeoutMsg, true);
    },

    async open(opts) {
      opts = opts || {};
      const win = document.getElementById('kma-chat-window');
      const btn = document.getElementById('kma-chat-toggle');
      const backdrop = document.getElementById('kma-chat-backdrop');
      if (!win) return;

      this._hideTooltip();
      win.classList.add('is-open');
      win.removeAttribute('aria-hidden');
      btn?.setAttribute('aria-expanded', 'true');
      backdrop?.classList.add('is-open');
      State.set('isOpen', true);
      Analytics.open();
      A11y.trapFocus(win);

      this._resetIdleTimer();

      if (!this._loaded) {
        await this._loadData();
      }

      const msgContainer = document.getElementById('kma-chat-messages');
      const isEmpty = !msgContainer || msgContainer.children.length === 0;
      const savedHtml = State.get('chatHtml');

      if (isEmpty && savedHtml && savedHtml.trim().length > 0) {
        /* 1. มีประวัติแชทเดิมที่คุยค้างไว้ (ยังไม่เกิน 1 ชม.) -> โหลดแชททั้งหมดกลับมาเหมือนเดิม */
        Renderer.restoreMessages(savedHtml);
        this._bindDynamicClicks();
        this._updateNav();
      } else if (isEmpty) {
        /* 2. ไม่มีประวัติ หรือหมดอายุ 1 ชม. -> แสดงหน้าต้อนรับ */
        await this._showGreeting();
      }
    },

    close() {
      if (this._idleTimer) clearTimeout(this._idleTimer);
      const win = document.getElementById('kma-chat-window');
      const btn = document.getElementById('kma-chat-toggle');
      const backdrop = document.getElementById('kma-chat-backdrop');
      if (!win) return;
      win.classList.remove('is-open');
      win.setAttribute('aria-hidden', 'true');
      btn?.setAttribute('aria-expanded', 'false');
      backdrop?.classList.remove('is-open');
      State.set('isOpen', false);
      A11y.releaseFocus(win);
      btn?.focus();
      Analytics.close();
    },

    /* Re-bind events for restored HTML (Bulletproof Global Event Delegation) */
    _bindDynamicClicks() {
      const msg = document.getElementById('kma-chat-messages');
      const self = this;
      if (!msg) return;
      
      /* Re-bind Home buttons */
      msg.querySelectorAll('.kma-js-home-btn').forEach(btn => {
        btn.onclick = () => this.goHome();
      });

      /* Re-bind Menu Buttons (กู้คืนปุ่มที่หลุดหลัง Refresh หรือเปลี่ยนหน้า) */
      msg.querySelectorAll('.kma-chat-menu__btn').forEach(btn => {
        if (!btn.disabled && !btn.onclick) {
          btn.onclick = () => {
            const query = btn.getAttribute('data-kma-query') || btn.textContent.trim();
            const title = btn.getAttribute('data-kma-title') || btn.textContent.trim();
            const wrapper = btn.closest('.kma-chat-menu-grid') || btn.parentElement;
            if (wrapper) {
              wrapper.querySelectorAll('.kma-chat-menu__btn').forEach(b => {
                b.disabled = true;
                b.classList.remove('is-selected');
              });
            }
            btn.classList.add('is-selected');
            self._handleDynamicQueryAction(query, title);
          };
        }
      });

      /* Re-bind Store Search Input Forms */
      msg.querySelectorAll('.kma-chat-store-search').forEach(form => {
        const input = form.querySelector('input');
        form.onsubmit = (e) => {
          e.preventDefault();
          const val = (input && input.value ? input.value : '').trim();
          if (val) {
            Renderer.addUserBubble(val);
            self._performStoreSearch(val);
          }
        };
      });

      /* Re-bind Carousel drag & arrows */
      msg.querySelectorAll('.kma-carousel-wrapper').forEach(wrap => {
        const track = wrap.querySelector('.kma-carousel');
        const prevBtn = wrap.querySelector('.kma-carousel__arrow--prev');
        const nextBtn = wrap.querySelector('.kma-carousel__arrow--next');
        if (!track || !prevBtn || !nextBtn) return;

        const slideW = () => {
          const s = track.querySelector('.kma-carousel__slide');
          if (!s) return 200;
          const gap = parseInt(getComputedStyle(track).gap || '10', 10);
          return s.offsetWidth + gap;
        };
        prevBtn.onclick = () => track.scrollBy({ left: -slideW(), behavior: 'smooth' });
        nextBtn.onclick = () => track.scrollBy({ left: slideW(), behavior: 'smooth' });

        const updateArrows = () => {
          prevBtn.disabled = track.scrollLeft <= 1;
          nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
        };
        track.onscroll = updateArrows;
        setTimeout(updateArrows, 100);
      });
    },

    /* ── ตัวประมวลผล Action จากปุ่มที่ถูกกู้คืนมาจาก Session ── */
    async _handleDynamicQueryAction(query, title) {
      if (!query) return;
      const self = this;
      const qLow = String(query).toLowerCase().trim();

      if (qLow === '_home' || qLow.includes('กลับ')) {
        this.goHome();
      } else if (qLow === '_best_sellers' || qLow.includes('ขายดี')) {
        await this._showProducts({ title: isEn ? 'Best Sellers' : 'สินค้าขายดี KMA', message: isEn ? 'Here are KMA\'s most popular items 💖' : 'นี่คือผลิตภัณฑ์ยอดนิยมของ KMA ที่สาวๆ ไว้วางใจค่ะ 💖' });
      } else if (qLow === '_skin_match' || qLow === 'advisor' || qLow.includes('แนะนำ') || qLow.includes('advisor')) {
        await this._showAdvisor({ action_type: 'advisor' });
      } else if (qLow === 'new_arrivals' || qLow.includes('สินค้าใหม่') || qLow.includes('new arrival')) {
        await this._showNewArrivals({ action_type: 'new_arrivals' });
      } else if (qLow === 'promotion' || qLow.includes('โปรโม') || qLow.includes('promo')) {
        await this._showPromotions({ action_type: 'promotion' });
      } else if (qLow === '_store_search' || qLow === 'store' || qLow === 'find_store' || qLow.includes('สาขา') || qLow.includes('store')) {
        await this._showStoreLocator();
      } else if (qLow === 'tracking' || qLow === 'order_tracking' || qLow.includes('พัสดุ') || qLow.includes('track')) {
        await this._showTracking({ action_type: 'tracking' });
      } else if (qLow === 'support' || qLow.includes('ติดต่อ') || qLow.includes('อื่น') || qLow.includes('support')) {
        await this._showSupport({ action_type: 'support' });
      } else if (qLow === '_gps_nearby') {
        this._findNearbyStoresGPS();
      } else if (qLow === '_region_bkk') {
        this._showBKKZoneSelector();
      } else if (qLow.startsWith('_region_')) {
        this._showSubRegionProvinces(query);
      } else if (qLow.startsWith('_bkk_')) {
        this._filterAndDisplayBKKZone(query, title);
      } else if (qLow === '_back_regions') {
        this._showStoreLocator();
      } else if (qLow.startsWith('_chon_')) {
        const allStores = (this._stores || []).filter(s => DataHelper.isActive(s));
        const provStores = allStores.filter(s => (s.province || '').toLowerCase().includes('ชลบุรี'));
        if (query === '_chon_all') {
          this._renderStoreSearchResults(provStores, isEn ? 'Chonburi' : 'จ.ชลบุรี');
        } else if (query === '_chon_muang') {
          const matches = provStores.filter(s => {
            const txt = (s.store_name + ' ' + s.address).toLowerCase();
            return txt.includes('เมือง') || txt.includes('เสม็ด') || txt.includes('ดอนหัวฬ่อ') || txt.includes('อมตะ') || txt.includes('บ้านบึง');
          });
          this._renderStoreSearchResults(matches.length ? matches : provStores, isEn ? 'Chonburi City / Amata' : 'ตัวเมืองชลบุรี / อมตะ / บ้านบึง');
        } else if (query === '_chon_pattaya') {
          const matches = provStores.filter(s => {
            const txt = (s.store_name + ' ' + s.address).toLowerCase();
            return txt.includes('พัทยา') || txt.includes('บางละมุง') || txt.includes('นาเกลือ') || txt.includes('หนองปรือ') || txt.includes('terminal 21');
          });
          this._renderStoreSearchResults(matches.length ? matches : provStores, isEn ? 'Pattaya / Banglamung' : 'พัทยา / บางละมุง');
        } else if (query === '_chon_sriracha') {
          const matches = provStores.filter(s => {
            const txt = (s.store_name + ' ' + s.address).toLowerCase();
            return txt.includes('ศรีราชา') || txt.includes('สุรศักดิ์') || txt.includes('บ่อวิน') || txt.includes('เจพาร์ค');
          });
          this._renderStoreSearchResults(matches.length ? matches : provStores, isEn ? 'Sriracha / Bowin' : 'ศรีราชา / บ่อวิน');
        }
      } else if (query === '_followup_yes') {
        Renderer.addBotBubble(t('followUpYesPrompt'));
        this._showMainMenu();
      } else if (query === '_followup_no') {
        Renderer.addBotBubble(t('followUpNoPrompt'));
        Renderer.addMenuButtons([
          { title: t('followUpShopAll'), query: '_shop_all' },
          { title: t('backToMainMenu'), query: '_home' }
        ], finalOpt => {
          if (finalOpt.query === '_shop_all') {
            Renderer.addUserBubble(finalOpt.title);
            window.location.href = isEn ? '/en/collections/all' : '/collections/all';
          } else {
            self.goHome();
          }
        });
      } else {
        const matchedMenu = (this._menus || []).find(m => m.handle === query || m.id === query || m.title === query || m.title === title);
        if (matchedMenu) {
          await this._executeNode(matchedMenu);
        } else {
          await this._showProvinceStores(query);
        }
      }
    },

    /* ── Load all Metaobject data once ── */
    async _loadData() {
      console.log('[KMA Chat] กำลังโหลดข้อมูลจาก Shopify Metaobjects...');
      try {
        const [m, r, c, a, s, stores] = await Promise.all([
          API.getMenuNodes(),
          API.getResponses(),
          API.getCards(),
          API.getAdvisorNodes(),
          API.getSupports(),
          API.getStoreLocations()
        ]);
        
        this._menus     = m.map(n => DataHelper.parseFields(n));
        this._responses = r.map(n => DataHelper.parseFields(n));
        this._cards     = c.map(n => DataHelper.parseFields(n));
        this._advisors  = a.map(n => DataHelper.parseFields(n));
        this._supports  = s.map(n => DataHelper.parseFields(n));
        this._stores    = stores.map(n => DataHelper.parseFields(n));
        this._loaded    = true;
        
        console.log('[KMA Chat] โหลดข้อมูลเสร็จสมบูรณ์:', {
          menus: this._menus,
          responses: this._responses,
          cards: this._cards,
          advisors: this._advisors,
          supports: this._supports,
          storesCount: this._stores.length
        });
      } catch (err) {
        console.error('[KMA Chat] เกิดข้อผิดพลาดขณะโหลดข้อมูล:', err);
      }
    },

    /* ── Greeting (3-Step Welcome Flow) ── */
    async _showGreeting() {
      Renderer.clearMessages();
      State.clearHistory();
      this._updateNav();

      /* กล่องที่ 1 — ทักทายต้อนรับ */
      const msg1 = t('greetingBox1');
      Renderer.addBotBubble(msg1, false);

      /* กล่องที่ 2 — แจ้งว่าเป็นระบบอัตโนมัติและข้อกำหนด */
      const msg2 = t('greetingBox2');
      Renderer.addBotBubble(msg2, false);

      /* กล่องที่ 3 — ชวนเลือกเมนู (พร้อม Timestamp) */
      const msg3 = t('greetingBox3');
      Renderer.addBotBubble(msg3, true);

      /* ตรวจสอบว่ามีรูป Welcome Card หรือ Support Banner หรือไม่ */
      const activeSupport = (this._supports || []).find(s => DataHelper.isActive(s));
      const welcomeImg = activeSupport?.image?.url || activeSupport?.image?.image?.url || Config.welcomeImage || '';
      
      if (welcomeImg) {
        let defaultCtaLabel = t('lineChatCta');
        if (activeSupport?.line_label) {
          defaultCtaLabel = activeSupport.line_label.startsWith('แชท') || activeSupport.line_label.startsWith('Chat') ? activeSupport.line_label : `แชทกับ KMA (${activeSupport.line_label})`;
        }

        const welcomeCardData = {
          image_url: welcomeImg,
          image_alt: 'KMA Cosmetics',
          url: activeSupport?.faq_url || '/collections/all',
          cta_label: defaultCtaLabel
        };

        Renderer.addWelcomeCard(welcomeCardData, () => {
          if (activeSupport?.line_url) {
            Analytics.clickSupport();
            window.open(activeSupport.line_url, '_blank', 'noopener,noreferrer');
          } else {
            const otherMenu = this._menus.find(m => m.action_type === 'support' || m.handle === 'other');
            if (otherMenu) this._onMenuSelect(otherMenu);
          }
        });
      }

      State.set('greetingShown', true);
      await this._wait(150);
      await this._showMainMenu();
    },

    /* ── Restore session state (3-Step Welcome Flow) ── */
    async _restoreState() {
      const history = State.get('history') || [];
      Renderer.clearMessages();

      /* กล่องที่ 1 */
      const msg1 = t('greetingBox1');
      Renderer.addBotBubble(msg1, false);

      /* กล่องที่ 2 */
      const msg2 = t('greetingBox2');
      Renderer.addBotBubble(msg2, false);

      /* กล่องที่ 3 */
      const msg3 = t('greetingBox3');
      Renderer.addBotBubble(msg3, true);

      /* Welcome Card */
      const activeSupport = (this._supports || []).find(s => DataHelper.isActive(s));
      const welcomeImg = activeSupport?.image?.url || activeSupport?.image?.image?.url || Config.welcomeImage || '';
      if (welcomeImg) {
        let defaultCtaLabel = t('lineChatCta');
        if (activeSupport?.line_label) {
          defaultCtaLabel = activeSupport.line_label.startsWith('แชท') || activeSupport.line_label.startsWith('Chat') ? activeSupport.line_label : `แชทกับ KMA (${activeSupport.line_label})`;
        }
        Renderer.addWelcomeCard({
          image_url: welcomeImg,
          image_alt: 'KMA Cosmetics',
          url: activeSupport?.faq_url || '/collections/all',
          cta_label: defaultCtaLabel
        }, () => {
          if (activeSupport?.line_url) {
            Analytics.clickSupport();
            window.open(activeSupport.line_url, '_blank', 'noopener,noreferrer');
          }
        });
      }

      if (!history.length) {
        await this._showMainMenu();
      } else {
        const current = history[history.length - 1];
        await this._executeNode(current);
      }
      this._updateNav();
    },

    /* ── Main Menu ── */
    async _showMainMenu() {
      const rootItems = DataHelper.sortItems(
        this._menus.filter(m => DataHelper.isActive(m) && !m.parent_menu?.handle)
      );

      if (!rootItems.length) {
        this._showFallbackMenu();
      } else {
        Renderer.addMenuButtons(rootItems, item => this._onMenuSelect(item));
      }
      Analytics.mainMenu();
    },

    /* Fallback menu when no Metaobjects set up yet */
    _showFallbackMenu() {
      const items = [
        { handle: 'new_arrivals', title: t('menu_new_arrivals'), icon: '✨', action_type: 'new_arrivals' },
        { handle: 'promotion',   title: t('menu_promotion'),    icon: '🎁', action_type: 'promotion'   },
        { handle: 'advisor',     title: t('menu_advisor'),      icon: '💄', action_type: 'advisor'     },
        { handle: 'store',       title: t('menu_store'),        icon: '📍', action_type: 'find_store'  },
        { handle: 'tracking',    title: t('menu_tracking'),     icon: '📦', action_type: 'tracking'    },
        { handle: 'support',     title: t('menu_support'),      icon: '💬', action_type: 'support'     }
      ];
      Renderer.addMenuButtons(items, item => this._onMenuSelect(item));
    },

    /* ── Handle menu selection ── */
    async _onMenuSelect(item) {
      const label = item.title || item.answer_label || item.node_title || '';
      const displayLabel = isEn ? localizeText(label, item.handle, item.action_type) : label;
      Renderer.addUserBubble(displayLabel);
      State.pushHistory(item);
      this._updateNav();

      /* Analytics map */
      const aMap = {
        new_arrivals:   () => Analytics.clickNewArrival(),
        promotion:      () => Analytics.clickPromotion(),
        advisor:        () => Analytics.clickAdvisor(),
        tracking:       () => Analytics.clickTracking(),
        order_tracking: () => Analytics.clickTracking(),
        support:        () => Analytics.clickSupport()
      };
      aMap[item.action_type]?.();

      const typing = Renderer.addTypingIndicator();
      await this._wait(TYPING_MS);
      Renderer.removeTypingIndicator(typing);
      await this._executeNode(item);
    },

    /* ── Route execution ── */
    async _executeNode(item) {
      switch (item.action_type) {
        case 'new_arrivals':   await this._showNewArrivals(item); break;
        case 'promotion':      await this._showPromotions(item);  break;
        case 'advisor':        await this._showAdvisor(item);     break;
        case 'store':
        case 'store_locator':
        case 'location':
        case 'find_store':     await this._showStoreLocator(item); break;
        case 'tracking':
        case 'order_tracking': await this._showTracking(item);    break;
        case 'support':        await this._showSupport(item);     break;
        case 'message':        await this._showMessage(item);     break;
        case 'link':           await this._showLink(item);        break;
        case 'product':        await this._showProduct(item);     break;
        case 'advisor_node':   await this._resumeAdvisorNode(item); break;
        case 'submenu':
        default:
          /* ตรวจสอบว่าเป็นเมนูค้นหาสาขาหรือไม่ */
          if (item.title?.includes('สาขา') || item.handle?.includes('store') || item.handle?.includes('location')) {
            await this._showStoreLocator(item);
          } else {
            await this._showSubmenu(item);
          }
          break;
      }
    },

    /* ── Smart Store Locator (Zero-Error 3-Layer Hybrid: GPS + Guided Regions + Smart Search) ── */
    async _showStoreLocator(item) {
      const self = this;
      const msg = item?.message || t('storeLocatorWelcome');
      Renderer.addBotBubble(msg);

      /* ปุ่มตัวเลือกหลัก: GPS + 6 ภูมิภาคยอดนิยม */
      const mainLocatorOptions = [
        { title: t('storeLocatorGps'),          query: '_gps_nearby' },
        { title: t('storeLocatorBkk'),          query: '_region_bkk' },
        { title: t('storeLocatorMetro'),        query: '_region_metro' },
        { title: t('storeLocatorEast'),         query: '_region_east' },
        { title: t('storeLocatorIsan'),         query: '_region_isan' },
        { title: t('storeLocatorSouth'),        query: '_region_south' },
        { title: t('storeLocatorNorthCentral'), query: '_region_north_central' }
      ];

      Renderer.addMenuButtons(mainLocatorOptions, opt => {
        Renderer.addUserBubble(opt.title);
        if (opt.query === '_gps_nearby') {
          self._findNearbyStoresGPS();
        } else if (opt.query === '_region_bkk') {
          self._showBKKZoneSelector();
        } else if (opt.query.startsWith('_region_')) {
          self._showSubRegionProvinces(opt.query);
        } else {
          self._showProvinceStores(opt.query);
        }
      });
    },

    /* ── 1-Click GPS Nearby Store Finder (คำนวณระยะทางจริงจากพิกัดมือถือ) ── */
    async _findNearbyStoresGPS() {
      const self = this;
      if (!navigator.geolocation) {
        Renderer.addBotBubble(t('gpsNoSupport'));
        self._showBKKZoneSelector();
        return;
      }

      const typing = Renderer.addTypingIndicator();
      Renderer.addBotBubble(t('gpsLocating'));

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          Renderer.removeTypingIndicator(typing);
          const userLat = pos.coords.latitude;
          const userLng = pos.coords.longitude;

          const allStores = (self._stores || []).filter(s => DataHelper.isActive(s));

          /* คำนวณระยะทางด้วยสูตร Haversine Formula */
          const calculateDistance = (lat1, lon1, lat2, lon2) => {
            const R = 6371; // รัศมีโลกเป็นกิโลเมตร
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                      Math.sin(dLon/2) * Math.sin(dLon/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c;
          };

          const storesWithDist = allStores.map(s => {
            let lat = parseFloat(s.latitude);
            let lng = parseFloat(s.longitude);
            if ((!lat || !lng) && s.map_url) {
              const match = s.map_url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)|q=(-?\d+\.\d+),(-?\d+\.\d+)/);
              if (match) {
                lat = parseFloat(match[1] || match[3]);
                lng = parseFloat(match[2] || match[4]);
              }
            }
            const dist = (lat && lng) ? calculateDistance(userLat, userLng, lat, lng) : 99999;
            return { ...s, distanceKm: dist };
          }).sort((a, b) => a.distanceKm - b.distanceKm);

          const validNearby = storesWithDist.filter(s => s.distanceKm < 99999).slice(0, 4);

          if (validNearby.length > 0 && validNearby[0].distanceKm <= 50) {
            Renderer.addBotBubble(t('gpsNearbyHeader'));
            validNearby.forEach(s => {
              const distText = t('approxDist', s.distanceKm.toFixed(1));
              s.floor = s.floor ? `${s.floor} ${distText}` : distText;
            });
            Renderer.addStoreCardsList(validNearby, 4, null);
            self._showFollowUpHelpPrompt();
          } else {
            Renderer.addBotBubble(t('gpsTooFar'));
            self._showBKKZoneSelector();
          }
        },
        (err) => {
          Renderer.removeTypingIndicator(typing);
          Renderer.addBotBubble(t('gpsFallback'));
          self._showBKKZoneSelector();
        },
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
      );
    },

    /* ── กรุงเทพมหานคร 60 สาขา (แบ่ง 4 โซนย่อย) ── */
    _showBKKZoneSelector() {
      const self = this;
      Renderer.addBotBubble(t('bkkPrompt'));

      const bkkZones = [
        { title: t('bkkCenter'), query: '_bkk_center' },
        { title: t('bkkNorth'),  query: '_bkk_north' },
        { title: t('bkkWest'),   query: '_bkk_west' },
        { title: t('bkkEast'),   query: '_bkk_east' },
        { title: t('backRegions'), query: '_back_regions' }
      ];

      Renderer.addMenuButtons(bkkZones, opt => {
        Renderer.addUserBubble(opt.title);
        if (opt.query === '_back_regions') {
          self._showStoreLocator();
        } else {
          self._filterAndDisplayBKKZone(opt.query, opt.title);
        }
      });
    },

    /* ── ตัวกรองสาขา 4 โซนใน กทม. ── */
    _filterAndDisplayBKKZone(zoneKey, zoneTitle) {
      const self = this;
      const allStores = (this._stores || []).filter(s => DataHelper.isActive(s));
      const bkkStores = allStores.filter(s => {
        const p = (s.province || '').toLowerCase();
        return p.includes('กรุงเทพ') || p.includes('กทม');
      });

      const zoneKeywords = {
        '_bkk_center': ['สยาม', 'เวิลด์', 'พารากอน', 'พระราม 9', 'พระราม9', 'สุขุมวิท', 'อโศก', 'สามย่าน', 'สีลม', 'mbk', 'ราชดำริ', 'วัน แบงค็อก', 'one bangkok', 'แพลทินัม', 'ศรีอยุธยา', 'เอกมัย', 'คลาวด์ 11', 'รัชดา', 'รอบทาวน์', 'สตรีท'],
        '_bkk_north':  ['ลาดพร้าว', 'ยูเนี่ยน', 'จตุจักร', 'รามอินทรา', 'อีสต์วิลล์', 'แฟชั่น', 'นวมินทร์', 'บางกะปิ', 'เกษตร', 'คู้บอน', 'แจ้งวัฒนะ', 'สุขาภิบาล', 'jc mall', 'charn'],
        '_bkk_west':   ['ปิ่นเกล้า', 'บางแค', 'ท่าพระ', 'พระราม 2', 'พระราม2', 'พระราม 3', 'พระราม3', 'ภาษีเจริญ', 'บางกอกน้อย', 'ทวีวัฒนา', 'กาญจนาภิเษก', 'พาซิโอ', 'เจริญกรุง', 'เอเชียทีค', 'บางรัก', 'ไอซีเอส', 'สาทร', 'ธนบุรี'],
        '_bkk_east':   ['บางนา', 'ศรีนครินทร์', 'ซีคอน', 'พาราไดซ์', 'ลาซาล', 'แบริ่ง', 'true digital', 'พระโขนง', 'parc']
      };

      const keys = zoneKeywords[zoneKey] || [];
      let matches = bkkStores.filter(s => {
        const txt = (s.store_name + ' ' + s.address).toLowerCase();
        return keys.some(k => txt.includes(k.toLowerCase()));
      });

      if (!matches.length) matches = bkkStores.slice(0, 15);

      const foundMsg = isEn
        ? `Found ${matches.length} KMA counters in **${zoneTitle}** 💖`
        : `พบจุดจำหน่าย KMA ในโซน **${zoneTitle}** ทั้งหมด ${matches.length} สาขาค่ะ 💖`;
      Renderer.addBotBubble(foundMsg);
      Renderer.addStoreCardsList(matches, matches.length, null);
      this._showFollowUpHelpPrompt();
    },

    /* ── แสดงรายชื่อจังหวัดในแต่ละภูมิภาค ── */
    _showSubRegionProvinces(regionKey) {
      const self = this;
      const allStores = (this._stores || []).filter(s => DataHelper.isActive(s));

      const regionMap = {
        '_region_metro': {
          titleTh: '5 จังหวัดปริมณฑล',
          titleEn: '5 Greater BKK Provinces',
          provs: [
            { nameTh: 'สมุทรปราการ', nameEn: 'Samut Prakan', descTh: '9 สาขา (เมกาบางนา / สำโรง / สุวรรณภูมิ)', descEn: '9 counters (Mega Bangna / Suvarnabhumi)' },
            { nameTh: 'นนทบุรี',      nameEn: 'Nonthaburi',   descTh: '8 สาขา (เวสต์วิลล์ / ราชพฤกษ์ / แจ้งวัฒนะ)', descEn: '8 counters (Westville / Chaengwattana)' },
            { nameTh: 'ปทุมธานี',     nameEn: 'Pathum Thani', descTh: '6 สาขา (ฟิวเจอร์พาร์ค รังสิต / นวนคร)', descEn: '6 counters (Future Park / Navanakorn)' },
            { nameTh: 'นครปฐม',      nameEn: 'Nakhon Pathom', descTh: '2 สาขา (เซ็นทรัล นครปฐม / บิ๊กซี)', descEn: '2 counters (Central Nakhon Pathom)' },
            { nameTh: 'สมุทรสาคร',    nameEn: 'Samut Sakhon', descTh: '1 สาขา (เซ็นทรัล มหาชัย)', descEn: '1 counter (Central Mahachai)' }
          ]
        },
        '_region_east': {
          titleTh: 'ภาคตะวันออก',
          titleEn: 'Eastern Region',
          provs: [
            { nameTh: 'ชลบุรี',      nameEn: 'Chonburi',    descTh: '16 สาขา (พัทยา / ศรีราชา / อมตะ / บ่อวิน)', descEn: '16 counters (Pattaya / Sriracha / Amata)' },
            { nameTh: 'ระยอง',      nameEn: 'Rayong',      descTh: '4 สาขา (เซ็นทรัล ระยอง / แหลมทอง / บ้านฉาง)', descEn: '4 counters (Central Rayong / Passione)' },
            { nameTh: 'ฉะเชิงเทรา',  nameEn: 'Chachoengsao', descTh: '2 สาขา (โรบินสัน แปดริ้ว / บิ๊กซี)', descEn: '2 counters (Robinson Padriew)' }
          ]
        },
        '_region_isan': {
          titleTh: 'ภาคตะวันออกเฉียงเหนือ (อีสาน)',
          titleEn: 'Northeastern Region (Isan)',
          provs: [
            { nameTh: 'ขอนแก่น',     nameEn: 'Khon Kaen',         descTh: '6 สาขา (เซ็นทรัล / แฟรี่ / บ้านไผ่)', descEn: '6 counters (Central / Fairy / Ban Phai)' },
            { nameTh: 'นครราชสีมา',  nameEn: 'Nakhon Ratchasima', descTh: '4 สาขา (เดอะมอลล์ โคราช / เทอร์มินอล 21 / ปากช่อง)', descEn: '4 counters (The Mall Korat / Terminal 21)' },
            { nameTh: 'อุดรธานี',     nameEn: 'Udon Thani',        descTh: '4 สาขา (ยูดี ทาวน์ / เซ็นทรัล / โลตัส)', descEn: '4 counters (UD Town / Central / Lotus)' },
            { nameTh: 'มุกดาหาร',    nameEn: 'Mukdahan',          descTh: '3 สาขา (โรบินสัน / อีฟแอนด์บอย)', descEn: '3 counters (Robinson / EVEANDBOY)' },
            { nameTh: 'สุรินทร์',     nameEn: 'Surin',             descTh: '3 สาขา (โรบินสัน / สุรินทร์พลาซ่า)', descEn: '3 counters (Robinson / Surin Plaza)' },
            { nameTh: 'อุบลราชธานี',  nameEn: 'Ubon Ratchathani',  descTh: '2 สาขา (เซ็นทรัล อุบล / สุนีย์ทาวเวอร์)', descEn: '2 counters (Central Ubon / Sunee Tower)' },
            { nameTh: 'หนองคาย',     nameEn: 'Nong Khai',         descTh: '2 สาขา (อัศวรรณ / โลตัส)', descEn: '2 counters (Asawann / Lotus)' },
            { nameTh: 'บุรีรัมย์',    nameEn: 'Buriram',           descTh: '2 สาขา (โรบินสัน / ทวีกิจ)', descEn: '2 counters (Robinson / Taweekit)' },
            { nameTh: 'ร้อยเอ็ด',     nameEn: 'Roi Et',            descTh: '1 สาขา (โรบินสัน)', descEn: '1 counter (Robinson)' },
            { nameTh: 'มหาสารคาม',   nameEn: 'Maha Sarakham',     descTh: '1 สาขา (เสริมไทย คอมเพล็กซ์)', descEn: '1 counter (Sermthai Complex)' },
            { nameTh: 'สกลนคร',     nameEn: 'Sakon Nakhon',      descTh: '1 สาขา (SK SQUARE)', descEn: '1 counter (SK SQUARE)' },
            { nameTh: 'ชัยภูมิ',      nameEn: 'Chaiyaphum',        descTh: '1 สาขา (โรบินสัน)', descEn: '1 counter (Robinson)' },
            { nameTh: 'อำนาจเจริญ',  nameEn: 'Amnat Charoen',     descTh: '1 สาขา (บิ๊กซี)', descEn: '1 counter (Big C)' }
          ]
        },
        '_region_south': {
          titleTh: 'ภาคใต้',
          titleEn: 'Southern Region',
          provs: [
            { nameTh: 'ภูเก็ต',           nameEn: 'Phuket',               descTh: '8 สาขา (เซ็นทรัล / จังซีลอน / ถลาง)', descEn: '8 counters (Central / Jungceylon / Thalang)' },
            { nameTh: 'สงขลา',           nameEn: 'Songkhla (Hatyai)',    descTh: '5 สาขา (หาดใหญ่ วิลเลจ / โลตัส ม.อ.)', descEn: '5 counters (Hatyai Village / Lotus PSU)' },
            { nameTh: 'สุราษฎร์ธานี',     nameEn: 'Surat Thani',          descTh: '4 สาขา (เซ็นทรัล / เกาะสมุย / สหไทย)', descEn: '4 counters (Central / Koh Samui / Sahathai)' },
            { nameTh: 'นครศรีธรรมราช',   nameEn: 'Nakhon Si Thammarat',  descTh: '4 สาขา (โรบินสัน โอเชี่ยน / สหไทย)', descEn: '4 counters (Robinson Ocean / Sahathai)' },
            { nameTh: 'ชุมพร',           nameEn: 'Chumphon',             descTh: '3 สาขา (โอเชี่ยน / โลตัส)', descEn: '3 counters (Ocean / Lotus)' },
            { nameTh: 'ตรัง',            nameEn: 'Trang',                descTh: '2 สาขา (โรบินสัน ตรัง)', descEn: '2 counters (Robinson Trang)' },
            { nameTh: 'ยะลา',            nameEn: 'Yala',                 descTh: '2 สาขา (โคลีเซี่ยม / โลตัส)', descEn: '2 counters (Coliseum / Lotus)' },
            { nameTh: 'กระบี่',           nameEn: 'Krabi',                descTh: '1 สาขา (โลตัส กระบี่)', descEn: '1 counter (Lotus Krabi)' },
            { nameTh: 'พัทลุง',           nameEn: 'Phatthalung',          descTh: '1 สาขา (โลตัส พัทลุง)', descEn: '1 counter (Lotus Phatthalung)' },
            { nameTh: 'ปัตตานี',          nameEn: 'Pattani',              descTh: '1 สาขา (ไดอาน่า คอมเพล็กซ์)', descEn: '1 counter (Diana Complex)' }
          ]
        },
        '_region_north_central': {
          titleTh: 'ภาคเหนือ & ภาคกลาง',
          titleEn: 'Northern & Central Region',
          provs: [
            { nameTh: 'เชียงใหม่',       nameEn: 'Chiang Mai',       descTh: '3 สาขา (เมญ่า / พันธุ์ทิพย์ / เซ็นทรัล แอร์พอร์ต)', descEn: '3 counters (MAYA / Central Airport)' },
            { nameTh: 'พิษณุโลก',       nameEn: 'Phitsanulok',      descTh: '3 สาขา (เซ็นทรัล / โรบินสัน / โลตัส)', descEn: '3 counters (Central / Robinson)' },
            { nameTh: 'กาญจนบุรี',      nameEn: 'Kanchanaburi',     descTh: '3 สาขา (โรบินสัน / โลตัส)', descEn: '3 counters (Robinson / Lotus)' },
            { nameTh: 'สระบุรี',        nameEn: 'Saraburi',         descTh: '3 สาขา (โรบินสัน / โลตัส)', descEn: '3 counters (Robinson / Lotus)' },
            { nameTh: 'สุพรรณบุรี',     nameEn: 'Suphan Buri',      descTh: '3 สาขา (โรบินสัน / โลตัส)', descEn: '3 counters (Robinson / Lotus)' },
            { nameTh: 'พระนครศรีอยุธยา', nameEn: 'Ayutthaya',        descTh: '2 สาขา (เซ็นทรัล อยุธยา / อยุธยาซิตี้พาร์ค)', descEn: '2 counters (Central Ayutthaya / City Park)' },
            { nameTh: 'ลำปาง',          nameEn: 'Lampang',          descTh: '2 สาขา (เซ็นทรัล / โรบินสัน)', descEn: '2 counters (Central / Robinson)' },
            { nameTh: 'กำแพงเพชร',      nameEn: 'Kamphaeng Phet',   descTh: '2 สาขา (โรบินสัน กำแพงเพชร)', descEn: '2 counters (Robinson Kamphaeng Phet)' },
            { nameTh: 'เพชรบุรี',        nameEn: 'Phetchaburi',      descTh: '2 สาขา (โรบินสัน เพชรบุรี)', descEn: '2 counters (Robinson Phetchaburi)' },
            { nameTh: 'ตาก',            nameEn: 'Tak',              descTh: '1 สาขา (โรบินสัน แม่สอด)', descEn: '1 counter (Robinson Mae Sot)' },
            { nameTh: 'เพชรบูรณ์',       nameEn: 'Phetchabun',       descTh: '1 สาขา (โลตัส)', descEn: '1 counter (Lotus)' },
            { nameTh: 'ปราจีนบุรี',      nameEn: 'Prachinburi',      descTh: '1 สาขา (โรบินสัน)', descEn: '1 counter (Robinson)' },
            { nameTh: 'นครนายก',        nameEn: 'Nakhon Nayok',     descTh: '1 สาขา (โลตัส)', descEn: '1 counter (Lotus)' },
            { nameTh: 'ราชบุรี',         nameEn: 'Ratchaburi',       descTh: '1 สาขา (โรบินสัน ราชบุรี)', descEn: '1 counter (Robinson Ratchaburi)' },
            { nameTh: 'สิงห์บุรี',        nameEn: 'Sing Buri',        descTh: '1 สาขา (ไชยแสง ดีพาร์ทเม้นท์)', descEn: '1 counter (Chaisaeng Department)' }
          ]
        }
      };

      const reg = regionMap[regionKey];
      if (!reg) { self._showBKKZoneSelector(); return; }

      const regTitle = isEn ? reg.titleEn : reg.titleTh;
      const promptMsg = isEn
        ? `Which province in **${regTitle}** would you like to search? 💖`
        : `คุณลูกค้าต้องการค้นหาจุดจำหน่ายในจังหวัดใดของ **${regTitle}** คะ? 💖`;
      Renderer.addBotBubble(promptMsg);

      const buttons = reg.provs.map(p => ({
        title: isEn ? `📍 ${p.nameEn} — ${p.descEn}` : `📍 ${p.nameTh} — ${p.descTh}`,
        query: p.nameTh
      }));
      buttons.push({ title: t('backRegions'), query: '_back_regions' });

      Renderer.addMenuButtons(buttons, opt => {
        if (opt.query === '_back_regions') {
          self._showStoreLocator({ message: isEn ? 'Which region would you like to search for counters? 💖' : 'คุณลูกค้าต้องการค้นหาสาขาในภูมิภาคไหนคะ? 💖' });
        } else {
          Renderer.addUserBubble(opt.title);
          self._showProvinceStores(opt.query);
        }
      });
    },

    /* ── ค้นหาสาขาตามจังหวัดที่เลือกจากปุ่ม (100% Zero-Error Guided Click) ── */
    async _showProvinceStores(provinceName) {
      const self = this;
      const targetProv = (provinceName || '').trim();
      if (!targetProv) return;

      const typing = Renderer.addTypingIndicator();
      await this._wait(40);
      Renderer.removeTypingIndicator(typing);

      const allStores = (this._stores || []).filter(s => DataHelper.isActive(s));

      /* จัดการพิเศษสำหรับ จ.ชลบุรี (16 สาขา แบ่ง 3 โซนท่องเที่ยว/เมือง) */
      if (targetProv.includes('ชลบุรี') || targetProv.toLowerCase() === 'chonburi') {
        const provStores = allStores.filter(s => (s.province || '').toLowerCase().includes('ชลบุรี'));
        Renderer.addBotBubble(isEn
          ? 'In **Chonburi**, KMA has 16 beauty counters ready to serve you 💖\nWhich area is most convenient for you?'
          : 'ใน **จ.ชลบุรี** มีจุดจำหน่ายเคาน์เตอร์ถึง 16 สาขาเลยค่ะ 💖\nคุณลูกค้าสะดวกเดินทางแถวโซนไหนคะ?');
        Renderer.addMenuButtons([
          { title: isEn ? '🏙️ Mueang Chonburi / Amata / Ban Bueng (5 counters)' : '🏙️ ตัวเมืองชลบุรี / อมตะ / บ้านบึง (5 สาขา)', query: '_chon_muang' },
          { title: isEn ? '🏖️ Pattaya / Bang Lamung (6 counters)' : '🏖️ พัทยา / บางละมุง (6 สาขา)', query: '_chon_pattaya' },
          { title: isEn ? '🛍️ Sriracha / Bo Win (5 counters)' : '🛍️ ศรีราชา / บ่อวิน (5 สาขา)', query: '_chon_sriracha' },
          { title: isEn ? '📋 View All 16 Counters in Chonburi' : '📋 ดูสาขาทั้งหมดในชลบุรี (16 สาขา)', query: '_chon_all' },
          { title: t('backRegions'), query: '_region_east' }
        ], opt => {
          Renderer.addUserBubble(opt.title);
          if (opt.query === '_region_east') {
            self._showSubRegionProvinces('_region_east');
          } else if (opt.query === '_chon_all') {
            self._renderStoreSearchResults(provStores, isEn ? 'Chonburi' : 'จ.ชลบุรี');
          } else if (opt.query === '_chon_muang') {
            const matches = provStores.filter(s => {
              const txt = (s.store_name + ' ' + s.address).toLowerCase();
              return txt.includes('เมือง') || txt.includes('เสม็ด') || txt.includes('ดอนหัวฬ่อ') || txt.includes('อมตะ') || txt.includes('บ้านบึง');
            });
            self._renderStoreSearchResults(matches.length ? matches : provStores, isEn ? 'Mueang Chonburi / Amata' : 'ตัวเมืองชลบุรี / อมตะ / บ้านบึง');
          } else if (opt.query === '_chon_pattaya') {
            const matches = provStores.filter(s => {
              const txt = (s.store_name + ' ' + s.address).toLowerCase();
              return txt.includes('พัทยา') || txt.includes('บางละมุง') || txt.includes('นาเกลือ') || txt.includes('หนองปรือ') || txt.includes('terminal 21');
            });
            self._renderStoreSearchResults(matches.length ? matches : provStores, isEn ? 'Pattaya / Bang Lamung' : 'พัทยา / บางละมุง');
          } else if (opt.query === '_chon_sriracha') {
            const matches = provStores.filter(s => {
              const txt = (s.store_name + ' ' + s.address).toLowerCase();
              return txt.includes('ศรีราชา') || txt.includes('สุรศักดิ์') || txt.includes('บ่อวิน') || txt.includes('เจพาร์ค');
            });
            self._renderStoreSearchResults(matches.length ? matches : provStores, isEn ? 'Sriracha / Bo Win' : 'ศรีราชา / บ่อวิน');
          }
        });
        return;
      }

      /* สำหรับจังหวัดอื่นๆ */
      const provStores = allStores.filter(s => {
        const p = (s.province || '').toLowerCase();
        return p.includes(targetProv.toLowerCase());
      });

      if (!provStores.length) {
        const notFoundMsg = isEn
          ? `Sorry, KMA does not have a counter in **${targetProv}** yet 💖\nYou can shop online 24/7 or choose another region below:`
          : `ขออภัยด้วยนะคะ ขณะนี้ KMA ยังไม่มีจุดจำหน่ายเคาน์เตอร์ในบริเวณ **จ.${targetProv}** ค่ะ 💖`;
        Renderer.addBotBubble(notFoundMsg);
        Renderer.addMenuButtons([
          { title: t('backRegions'), query: '_back_regions' },
          { title: t('backToMainMenu'), query: '_home' }
        ], opt => {
          if (opt.query === '_home') self.goHome();
          else self._showStoreLocator();
        });
        return;
      }

      /* แสดงการ์ดผลลัพธ์สาขาทั้งหมดในจังหวัดนั้นทันที */
      this._renderStoreSearchResults(provStores, isEn ? targetProv : ('จ.' + targetProv));
    },

    /* เรนเดอร์ผลลัพธ์สาขา */
    _renderStoreSearchResults(results, queryText) {
      const self = this;
      if (!results || !results.length) {
        Renderer.addBotBubble(isEn ? 'Which province or area are you looking for? 💖' : 'สวัสดีค่ะ 💖 ไม่ทราบว่าตอนนี้คุณลูกค้าอยู่ **จังหวัด** อะไร หรือต้องการค้นหาสาขาแถวไหนคะ?');
        
        /* ปุ่มช่วยเลือกจังหวัดยอดนิยม เพื่อนำทางลูกค้าต่อทันที */
        const quickChips = isEn ? [
          { title: 'Bangkok & Metro', query: 'กรุงเทพ' },
          { title: 'Chiang Mai',      query: 'เชียงใหม่' },
          { title: 'Chonburi / Pattaya', query: 'ชลบุรี' },
          { title: 'Khon Kaen',        query: 'ขอนแก่น' },
          { title: 'Phuket / Surat',   query: 'ภูเก็ต' }
        ] : [
          { title: 'กรุงเทพฯ / ปริมณฑล', query: 'กรุงเทพ' },
          { title: 'เชียงใหม่',        query: 'เชียงใหม่' },
          { title: 'ชลบุรี / พัทยา',    query: 'ชลบุรี' },
          { title: 'ขอนแก่น',          query: 'ขอนแก่น' },
          { title: 'สุราษฎร์ธานี',      query: 'สุราษฎร์ธานี' }
        ];

        Renderer.addMenuButtons(quickChips, opt => {
          Renderer.addUserBubble(opt.title);
          self._performStoreSearch(opt.query);
        });

        Renderer.addStoreSearchBox(isEn ? 'Type province or mall name...' : 'พิมพ์ชื่อจังหวัด หรือ ห้าง...', newQ => {
          Renderer.addUserBubble(newQ);
          self._performStoreSearch(newQ);
        });
        return;
      }

      /* ข้อความผลลัพธ์ สะอาดตา อ่านง่าย ไม่มีอิโมจิรบกวน */
      const foundMsg = isEn ? `Found ${results.length} KMA counters in "${queryText}":` : `พบจุดจำหน่าย KMA ในบริเวณ "${queryText}" ทั้งหมด ${results.length} สาขาค่ะ`;
      Renderer.addBotBubble(foundMsg);

      let displayedCount = 0;
      const PAGE_SIZE = 30;

      const showNextBatch = () => {
        const nextBatch = results.slice(displayedCount, displayedCount + PAGE_SIZE);
        displayedCount += nextBatch.length;
        Renderer.addStoreCardsList(nextBatch, results.length, displayedCount < results.length ? showNextBatch : null, queryText);
      };

      showNextBatch();

      /* ถามต่อยอดเมื่อแสดงผลลัพธ์ครบถ้วน (Follow-up Engagement Loop) */
      this._showFollowUpHelpPrompt();
    },

    /* ── Follow-up Engagement Prompt ── */
    _showFollowUpHelpPrompt() {
      const self = this;
      Renderer.addBotBubble(t('followUpPrompt'));
      Renderer.addMenuButtons([
        { title: t('followUpYes'), query: '_followup_yes' },
        { title: t('followUpNo'), query: '_followup_no' },
        { title: t('backToMainMenu'), query: '_home' }
      ], opt => {
        if (opt.query === '_followup_yes') {
          Renderer.addUserBubble(opt.title);
          Renderer.addBotBubble(t('followUpYesPrompt'));
          self._showMainMenu();
        } else if (opt.query === '_followup_no') {
          Renderer.addUserBubble(opt.title);
          Renderer.addBotBubble(t('followUpNoPrompt'));
          Renderer.addMenuButtons([
            { title: t('followUpShopAll'), query: '_shop_all' },
            { title: t('backToMainMenu'), query: '_home' }
          ], finalOpt => {
            if (finalOpt.query === '_shop_all') {
              Renderer.addUserBubble(finalOpt.title);
              window.location.href = isEn ? '/en/collections/all' : '/collections/all';
            } else {
              self.goHome();
            }
          });
        } else {
          self.goHome();
        }
      });
      Renderer.scrollToBottom();
    },

    /* ── Submenu ── */
    async _showSubmenu(parent) {
      if (parent.message) Renderer.addBotBubble(parent.message);
      const children = DataHelper.sortItems(
        this._menus.filter(m => DataHelper.isActive(m) && (m.parent_menu?.id === parent.id || m.parent_menu?.handle === parent.handle))
      );
      if (!children.length) {
        Renderer.addEmptyState('ยังไม่มีเนื้อหาในส่วนนี้ค่ะ', () => this.goHome());
        return;
      }
      Renderer.addMenuButtons(children, child => this._onMenuSelect(child));
    },

    /* ── New Arrivals ── */
    async _showNewArrivals(item) {
      const defaultMsg = isEn ? 'Discover the latest arrivals from KMA Cosmetics ✨\nExplore items below:' : 'พบกับสินค้าใหม่ล่าสุดจาก KMA\nเลือกดูไอเท็มที่คุณสนใจได้เลยค่ะ';
      const msg = isEn ? defaultMsg : (item.message || defaultMsg);
      Renderer.addBotBubble(msg);

      /* รองรับการเชื่อมโยงทั้ง 2 ทาง:
         1. Menu.content -> ชี้ไปที่ Content ID / Handle (ตรงกับ Metaobject ของ KMA)
         2. Content.parent_menu -> ชี้มาที่ Menu ID / Handle
         3. Handle ตรงกัน เช่น item.handle === response.handle
      */
      const contentTargetId = item.content?.id || (typeof item.content === 'string' ? item.content : null);
      const contentTargetHandle = item.content?.handle || (typeof item.content === 'string' ? item.content : null);

      const responses = DataHelper.sortItems(
        this._responses.filter(r => {
          const isActive = DataHelper.isActive(r);
          const matchByContentId = contentTargetId && (r.id === contentTargetId);
          const matchByContentHandle = contentTargetHandle && (r.handle === contentTargetHandle);
          const matchByParentId = r.parent_menu?.id === item.id;
          const matchByParentHandle = r.parent_menu?.handle === item.handle;
          const matchBySameHandle = r.handle === item.handle;

          return isActive && (matchByContentId || matchByContentHandle || matchByParentId || matchByParentHandle || matchBySameHandle);
        })
      );

      console.log('[KMA Chat] พบ Responses สำหรับสินค้าใหม่:', responses);

      if (!responses.length) {
        Renderer.addEmptyState(isEn ? 'No new arrivals available at the moment' : 'ยังไม่มีสินค้าใหม่ในขณะนี้ค่ะ', () => this.goHome());
        return;
      }
      for (const r of responses) await this._renderResponse(r, 'new_arrivals');
      this._showFollowUpHelpPrompt();
    },

    /* ── Promotions ── */
    async _showPromotions(item) {
      const defaultMsg = isEn ? 'Special promotions and exclusive deals from KMA Cosmetics 🔥✨' : 'ดูโปรโมชั่นและสิทธิพิเศษล่าสุดจาก KMA ได้ที่นี่ค่ะ';
      const msg = isEn ? defaultMsg : (item.message || defaultMsg);
      Renderer.addBotBubble(msg);

      const contentTargetId = item.content?.id || (typeof item.content === 'string' ? item.content : null);
      const contentTargetHandle = item.content?.handle || (typeof item.content === 'string' ? item.content : null);

      const responses = DataHelper.sortItems(
        this._responses.filter(r => {
          const isActive = DataHelper.isActive(r);
          const matchByContentId = contentTargetId && (r.id === contentTargetId);
          const matchByContentHandle = contentTargetHandle && (r.handle === contentTargetHandle);
          const matchByParentId = r.parent_menu?.id === item.id;
          const matchByParentHandle = r.parent_menu?.handle === item.handle;
          const matchBySameHandle = r.handle === item.handle;

          return isActive && (matchByContentId || matchByContentHandle || matchByParentId || matchByParentHandle || matchBySameHandle);
        })
      );

      if (!responses.length) {
        this._showNoPromotion();
        return;
      }

      let hasContent = false;
      for (const r of responses) {
        /* ตรวจสอบ Cards Carousel */
        if (r.response_type === 'carousel' && Array.isArray(r.related_cards) && r.related_cards.length) {
          const activeCards = DataHelper.sortItems(
            this._cards.filter(c => {
              const match = (r.related_cards || []).some(rc => rc.id === c.id || rc.handle === c.handle);
              return match && DataHelper.isActive(c);
            })
          );
          if (activeCards.length) {
            hasContent = true;
            await this._renderCarouselOfCards(activeCards, 'promotion');
          } else {
            hasContent = true;
            await this._renderCarouselOfCards(r.related_cards.map(c => DataHelper.parseFields(c)), 'promotion');
          }
        } else {
          hasContent = true;
          await this._renderResponse(r, 'promotion');
        }
      }
      if (!hasContent) {
        this._showNoPromotion();
      } else {
        this._showFollowUpHelpPrompt();
      }
    },

    _showNoPromotion() {
      Renderer.addBotBubble(isEn ? 'No special promotions available at the moment.\nFeel free to explore all KMA products!' : 'ตอนนี้ยังไม่มีโปรโมชั่นพิเศษค่ะ\nสามารถเลือกดูสินค้าอื่น ๆ จาก KMA ได้เลย');
      Renderer.addLinkButton(isEn ? 'Shop All Products' : 'ดูสินค้าทั้งหมด', isEn ? '/en/collections/all' : '/collections/all', false);
      Renderer.addMenuButtons([{ handle: '_home', title: t('backToMainMenu'), icon: '' }], () => this.goHome());
    },

    /* ── Product Advisor ── */
    async _showAdvisor(item) {
      const defaultMsg = isEn ? 'Sure! 💄✨\nWhich category of beauty products are you looking for?' : 'ได้เลยค่ะ 💄✨\nตอนนี้กำลังมองหาผลิตภัณฑ์ประเภทไหนอยู่คะ?';
      const msg = isEn ? defaultMsg : (item.message || defaultMsg);
      Renderer.addBotBubble(msg);
      const roots = DataHelper.sortItems(
        this._advisors.filter(n => DataHelper.isActive(n) && !n.parent_node?.handle)
      );
      if (!roots.length) {
        /* Fallback categories พร้อม Link ไปยัง Collection ของ KMA */
        const cats = [
          { handle: 'foundation',   title: isEn ? 'Foundation' : 'รองพื้น',           url: isEn ? '/en/collections/foundation' : '/collections/foundation', msg: isEn ? 'KMA offers a wide range of popular foundations: matte, full coverage, and dewy glow formulas 💖' : 'KMA มีรองพื้นยอดนิยมหลายสูตร ทั้งสูตรคุมมัน ปกปิดเนียนกริบ และสูตรงานผิวฉ่ำโกลว์ค่ะ 💖' },
          { handle: 'cushion',      title: isEn ? 'Cushion' : 'คุชชั่น',              url: isEn ? '/en/collections/cushion' : '/collections/cushion',       msg: isEn ? 'KMA Cushions deliver natural flawless skin, portable and touch-up friendly without cakey finish ✨' : 'คุชชั่น KMA งานผิวสวยเป็นธรรมชาติ พกพาสะดวก เติมระหว่างวันได้ไม่เป็นคราบค่ะ ✨' },
          { handle: 'powder',       title: isEn ? 'Powder' : 'แป้ง',                 url: isEn ? '/en/collections/powder' : '/collections/powder',         msg: isEn ? 'KMA Pressed & Translucent powders set your makeup with all-day oil control 🌸' : 'แป้งผสมรองพื้นและแป้งโปร่งแสง KMA ช่วยเซ็ตผิว คุมมันยาวนานตลอดวันค่ะ 🌸' },
          { handle: 'primer',       title: isEn ? 'Primer' : 'ไพรเมอร์',             url: isEn ? '/en/collections/primer' : '/collections/primer',         msg: isEn ? 'KMA Primers blur pores and smooth skin texture for long-lasting makeup 💫' : 'ไพรเมอร์ KMA ช่วยเบลอรูขุมขน ปรับผิวให้เนียนเรียบ เมคอัพติดทนยิ่งขึ้นค่ะ 💫' },
          { handle: 'point-makeup', title: isEn ? 'Point Makeup' : 'พอยต์เมคอัพ',     url: isEn ? '/en/collections/all' : '/collections/all',               msg: isEn ? 'Lipsticks, blushes, and vibrant color items from KMA with rich pigmentation 💄' : 'ลิปสติก บลัชออน และเมคอัพแต่งแต้มสีสันจาก KMA สีสวยชัด ติดทนนานค่ะ 💄' },
          { handle: 'skincare',     title: isEn ? 'Skincare' : 'สกินแคร์',             url: isEn ? '/en/collections/skincare' : '/collections/skincare',     msg: isEn ? 'Hydrating and brightening skincare designed to prep skin before makeup 🌿' : 'ผลิตภัณฑ์บำรุงผิวเพื่อผิวชุ่มชื้น กระจ่างใส และเตรียมผิวให้พร้อมสำหรับการแต่งหน้าค่ะ 🌿' },
          { handle: 'tools',        title: isEn ? 'Makeup Tools' : 'อุปกรณ์แต่งหน้า',   url: isEn ? '/en/collections/tools' : '/collections/tools',           msg: isEn ? 'Professional quality brushes and sponges for seamless blending 🖌️' : 'แปรงแต่งหน้าและพัฟคุณภาพเยี่ยม ช่วยให้เกลี่ยเมคอัพได้สวยเนียนระดับโปรค่ะ 🖌️' }
        ];
        Renderer.addMenuButtons(cats, cat => {
          Analytics.categorySelect(cat.handle);
          Renderer.addUserBubble(cat.title);
          Renderer.addBotBubble(cat.msg);
          Renderer.addLinkButton(isEn ? `View all ${cat.title} products` : `ดูสินค้าหมวด${cat.title}ทั้งหมด`, cat.url, false);
          this._showFollowUpHelpPrompt();
        });
        return;
      }
      Renderer.addMenuButtons(roots, async node => {
        Analytics.categorySelect(node.handle);
        const label = isEn ? localizeText(node.answer_label || node.node_title, node.handle, 'advisor') : (node.answer_label || node.node_title);
        Renderer.addUserBubble(label);
        State.pushHistory({ action_type: 'advisor_node', _nodeHandle: node.handle });
        this._updateNav();
        const typing = Renderer.addTypingIndicator();
        await this._wait(TYPING_MS);
        Renderer.removeTypingIndicator(typing);
        await this._showAdvisorNode(node);
      });
    },

    /* ── Resume advisor node (from history) ── */
    async _resumeAdvisorNode(item) {
      const node = this._advisors.find(n => n.handle === item._nodeHandle);
      if (!node) { await this._showMainMenu(); return; }
      await this._showAdvisorNode(node);
    },

    /* ── Advisor node: show question + choices or results ── */
    async _showAdvisorNode(node) {
      /* Leaf node → show products */
      const products = Array.isArray(node.recommended_products)
        ? node.recommended_products.filter(p => p.__typename === 'Product' || p.handle)
        : [];
      if (products.length) {
        Renderer.addBotBubble(isEn ? 'Based on your selection, KMA recommends these items:' : 'จากข้อมูลที่เลือก KMA แนะนำไอเท็มเหล่านี้ค่ะ');
        if (products.length === 1) {
          Renderer.addProductCard(products[0], 'product_advisor');
        } else {
          Renderer.addCarousel(products, p => {
            const norm = DataHelper.normalizeProduct(p);
            return norm ? Renderer._buildProductCardEl(norm, 'product_advisor') : null;
          });
        }
        this._updateNav();
        this._showFollowUpHelpPrompt();
        return;
      }

      /* Branch node → show question and child choices */
      if (node.question) Renderer.addBotBubble(node.question);
      const children = DataHelper.sortItems(
        this._advisors.filter(n => DataHelper.isActive(n) && n.parent_node?.handle === node.handle)
      );
      if (!children.length) {
        Renderer.addEmptyState(isEn ? 'No details available in this section' : 'ยังไม่มีข้อมูลในส่วนนี้ค่ะ', () => this.goHome());
        return;
      }
      Renderer.addMenuButtons(children, async child => {
        const label = isEn ? localizeText(child.answer_label || child.node_title, child.handle, 'advisor') : (child.answer_label || child.node_title);
        Analytics.advisorAnswer(label);
        Renderer.addUserBubble(label);
        State.pushHistory({ action_type: 'advisor_node', _nodeHandle: child.handle });
        this._updateNav();
        const typing = Renderer.addTypingIndicator();
        await this._wait(TYPING_MS);
        Renderer.removeTypingIndicator(typing);
        await this._showAdvisorNode(child);
      });
    },

    /* ── Order Tracking ── */
    async _showTracking(item) {
      const contentTargetId = item.content?.id || (typeof item.content === 'string' ? item.content : null);
      const contentTargetHandle = item.content?.handle || (typeof item.content === 'string' ? item.content : null);

      const matchedResponse = this._responses.find(r => {
        const isActive = DataHelper.isActive(r);
        const matchByContentId = contentTargetId && (r.id === contentTargetId);
        const matchByContentHandle = contentTargetHandle && (r.handle === contentTargetHandle);
        const matchByParentId = r.parent_menu?.id === item.id;
        const matchByParentHandle = r.parent_menu?.handle === item.handle;
        const matchBySameHandle = r.handle === item.handle;

        return isActive && (matchByContentId || matchByContentHandle || matchByParentId || matchByParentHandle || matchBySameHandle);
      });

      if (matchedResponse) {
        await this._renderResponse(matchedResponse, 'tracking');
      } else {
        const defaultMsg = isEn ? 'Want to check your order delivery status? 📦\nYou can track your shipment directly via our tracking page below:' : 'ต้องการตรวจสอบสถานะคำสั่งซื้อใช่ไหมคะ?\nสามารถตรวจสอบได้จากหน้าติดตามพัสดุ';
        const msg = isEn ? defaultMsg : (item.message || defaultMsg);
        Renderer.addBotBubble(msg);
        const url = (item.action_target && item.action_target.trim()) || Config.trackingUrl || '/pages/order-tracking';
        Renderer.addLinkButton(isEn ? '📦 Track Your Order' : 'ตรวจสอบสถานะคำสั่งซื้อ', url, false, () => Analytics.clickTracking());
      }
      this._showFollowUpHelpPrompt();
    },

    /* ── Support ── */
    async _showSupport(item) {
      const self = this;
      const supportTargetId = item.support?.id || (typeof item.support === 'string' ? item.support : null);
      const supportTargetHandle = item.support?.handle || (typeof item.support === 'string' ? item.support : null);

      /* ค้นหา Support Node จาก kma_chat_support */
      const targetSupport = (this._supports || []).find(s => {
        const isActive = DataHelper.isActive(s);
        const matchBySupportField = (supportTargetId && s.id === supportTargetId) || (supportTargetHandle && s.handle === supportTargetHandle);
        const matchByRef = (s.references || []).some(ref => ref.id === item.id || ref.handle === item.handle);
        const matchById = s.id === item.content?.id || s.id === item.id;
        const matchByHandle = s.handle === item.content?.handle || s.handle === item.handle;
        return isActive && (matchBySupportField || matchByRef || matchById || matchByHandle);
      }) || (this._supports || []).find(s => DataHelper.isActive(s));

      if (targetSupport) {
        const defaultMsg = isEn ? 'How can KMA Customer Support assist you today? 💖' : 'ต้องการให้ KMA ช่วยเรื่องไหนเพิ่มเติมคะ?';
        const msg = isEn ? defaultMsg : (item.message || targetSupport.message || defaultMsg);
        Renderer.addBotBubble(msg);

        if (targetSupport.image?.url || targetSupport.image?.image?.url) {
          const imgUrl = targetSupport.image?.url || targetSupport.image?.image?.url;
          Renderer.addImage(imgUrl, targetSupport.support_topic || 'KMA Support');
        }

        /* เมนูตัวเลือกบริการ Support */
        const supportButtons = [];
        if (targetSupport.line_url) {
          const rawLabel = targetSupport.line_label || '';
          const lineLabel = rawLabel && !rawLabel.includes('Label') ? rawLabel : (isEn ? 'Chat via LINE' : 'ติดต่อผ่าน LINE');
          supportButtons.push({ title: lineLabel, query: '_support_line', url: targetSupport.line_url });
        }
        if (targetSupport.facebook_url) {
          const rawLabel = targetSupport.facebook_label || '';
          const fbLabel = rawLabel && !rawLabel.includes('Label') ? rawLabel : (isEn ? 'Chat via Facebook' : 'ติดต่อผ่าน Facebook');
          supportButtons.push({ title: fbLabel, query: '_support_fb', url: targetSupport.facebook_url });
        }
        if (targetSupport.faq_url) {
          const rawLabel = targetSupport.faq_label || '';
          const faqLabel = rawLabel && !rawLabel.includes('Label') ? rawLabel : (isEn ? 'FAQs' : 'คำถามที่พบบ่อย (FAQs)');
          supportButtons.push({ title: faqLabel, query: '_support_faq', url: targetSupport.faq_url });
        }

        if (supportButtons.length) {
          Renderer.addMenuButtons(supportButtons, btn => {
            Renderer.addUserBubble(btn.title);
            Analytics.clickSupport();
            
            if (btn.query === '_support_faq') {
              Renderer.addBotBubble(isEn ? 'You can view our Frequently Asked Questions (FAQs) here:' : 'คุณลูกค้าสามารถดูคำถามที่พบบ่อย (FAQs) ได้ที่นี่ค่ะ:');
              Renderer.addLinkButton(btn.title, btn.url, false);
            } else if (btn.query === '_support_line') {
              Renderer.addBotBubble(isEn ? 'Contact our team via LINE Official below:' : 'คุณลูกค้าสามารถติดต่อทีมงาน KMA ผ่าน LINE Official ได้ที่นี่ค่ะ:');
              Renderer.addLinkButton(btn.title, btn.url, true);
            } else if (btn.query === '_support_fb') {
              Renderer.addBotBubble(isEn ? 'Contact our team via Facebook Messenger below:' : 'คุณลูกค้าสามารถติดต่อทีมงาน KMA ผ่าน Facebook Messenger ได้ที่นี่ค่ะ:');
              Renderer.addLinkButton(btn.title, btn.url, true);
            } else {
              Renderer.addLinkButton(btn.title, btn.url, true);
            }

            /* แสดงคำถามปิดท้าย */
            self._showFollowUpHelpPrompt();
          });
        }
        return;
      }

      /* Fallback topics ถ้ายังไม่ได้ตั้งค่า KMA Support */
      const msg = item.message || 'ต้องการติดต่อ KMA เกี่ยวกับเรื่องใดคะ?';
      Renderer.addBotBubble(msg);
      const topics = DataHelper.sortItems(
        this._menus.filter(m => DataHelper.isActive(m) && (m.parent_menu?.id === item.id || m.parent_menu?.handle === item.handle))
      );
      if (!topics.length) {
        const fallback = [
          { handle: 'order-issue', title: 'ปัญหาการสั่งซื้อ',             action_type: 'support_result' },
          { handle: 'payment',     title: 'การชำระเงิน',                   action_type: 'support_result' },
          { handle: 'shipping',    title: 'การจัดส่ง',                     action_type: 'support_result' },
          { handle: 'damaged',     title: 'ได้รับสินค้าผิด / สินค้าเสียหาย', action_type: 'support_result' },
          { handle: 'product-info',title: 'สอบถามข้อมูลสินค้า',            action_type: 'support_result' },
          { handle: 'other',       title: 'เรื่องอื่น ๆ',                   action_type: 'support_result' }
        ];
        Renderer.addMenuButtons(fallback, async t => { await this._onSupportTopicSelect(t); });
        return;
      }
      Renderer.addMenuButtons(topics, async t => { await this._onSupportTopicSelect(t); });
    },

    async _onSupportTopicSelect(topic) {
      Renderer.addUserBubble(topic.title);
      Analytics.supportClick(topic.handle);
      State.pushHistory(topic);
      this._updateNav();
      const typing = Renderer.addTypingIndicator();
      await this._wait(TYPING_MS);
      Renderer.removeTypingIndicator(typing);
      await this._showSupportResult(topic);
    },

    async _showSupportResult(topic) {
      const self = this;
      Renderer.addBotBubble(isEn ? 'KMA team is here to assist you 💖' : 'ทีม KMA พร้อมช่วยดูแลค่ะ');
      const contactResponses = DataHelper.sortItems(
        this._responses.filter(r => DataHelper.isActive(r) && (r.parent_menu?.id === topic.id || r.parent_menu?.handle === topic.handle))
      );
      if (!contactResponses.length) {
        /* Fallback contact links */
        const supportSubButtons = [
          { title: isEn ? 'Chat via LINE' : 'ติดต่อผ่าน LINE', url: Config.lineUrl || 'https://line.me/ti/p/@kmacosmetics', isExt: true, query: '_sub_line' },
          { title: isEn ? 'Chat via Facebook' : 'ติดต่อผ่าน Facebook', url: Config.facebookUrl || 'https://www.facebook.com/kmacosmetics', isExt: true, query: '_sub_fb' },
          { title: isEn ? 'Frequently Asked Questions (FAQs)' : 'คำถามที่พบบ่อย (FAQs)', url: Config.faqUrl || '/pages/faq', isExt: false, query: '_sub_faq' }
        ];

        Renderer.addMenuButtons(supportSubButtons, btn => {
          Renderer.addUserBubble(btn.title);
          if (btn.query === '_sub_faq') {
            Renderer.addBotBubble(isEn ? 'You can view our Frequently Asked Questions (FAQs) here:' : 'คุณลูกค้าสามารถดูคำถามที่พบบ่อย (FAQs) ได้ที่นี่ค่ะ:');
          } else {
            Renderer.addBotBubble(isEn ? `You can ${btn.title.toLowerCase()} below:` : `คุณลูกค้าสามารถ${btn.title}ได้ที่นี่ค่ะ:`);
          }
          Renderer.addLinkButton(btn.title, btn.url, btn.isExt);
          self._showFollowUpHelpPrompt();
        });
        return;
      }
      for (const r of contactResponses) await this._renderResponse(r, 'support');
      this._showFollowUpHelpPrompt();
    },

    /* ── Message only ── */
    async _showMessage(item) {
      if (item.message) Renderer.addBotBubble(item.message);
    },

    /* ── Link ── */
    async _showLink(item) {
      if (item.message) Renderer.addBotBubble(item.message);
      const url = item.action_target || '#';
      const isExt = url.startsWith('http') && !url.includes(Config.shopDomain || '');
      Renderer.addLinkButton(item.title || 'ดูเพิ่มเติม', url, isExt);
    },

    /* ── Single product (from Metaobject handle) ── */
    async _showProduct(item) {
      const handle = item.action_target;
      if (!handle) return;
      const p = await API.getProduct(handle);
      if (!p) { Renderer.addErrorState(() => this._showProduct(item), () => this.goHome()); return; }
      Renderer.addProductCard(p, 'chat');
    },

    /* ── Render a response object ── */
    async _renderResponse(response, source) {
      source = source || 'chat';
      const type = response.response_type || 'text';

      switch (type) {
        case 'text':
          if (response.message) Renderer.addBotBubble(response.message);
          break;

        case 'image':
          if (response.image?.url || response.image?.image?.url) {
            const url = response.image?.url || response.image?.image?.url;
            const alt = response.image_alt || response.image?.altText || '';
            Renderer.addImage(url, alt);
          }
          if (response.message) Renderer.addBotBubble(response.message);
          break;

        case 'image_text':
          if (response.image?.url || response.image?.image?.url) {
            const url = response.image?.url || response.image?.image?.url;
            Renderer.addImage(url, response.image_alt || '');
          }
          if (response.message) Renderer.addBotBubble(response.message);
          break;

        case 'single_card':
          Renderer.addCard({
            image:       response.image,
            image_alt:   response.image_alt,
            title:       response.title,
            description: response.message,
            cta_label:   response.cta_label,
            cta_url:     response.cta_url
          });
          break;

        case 'carousel': {
          const cardHandles = (response.related_cards || []).map(c => c.handle).filter(Boolean);
          const cards = DataHelper.sortItems(
            this._cards.filter(c => cardHandles.includes(c.handle) && DataHelper.isActive(c))
          );
          if (cards.length) await this._renderCarouselOfCards(cards, source);
          break;
        }

        case 'product': {
          const p = response.related_product;
          if (p?.handle) {
            const full = await API.getProduct(p.handle);
            Renderer.addProductCard(full || p, source);
          }
          break;
        }

        case 'product_carousel': {
          console.log('[KMA Chat] กำลังประมวลผล product_carousel สำหรับ response:', response);
          let prods = (Array.isArray(response.related_products) ? response.related_products : [])
            .filter(p => p.handle);
            
          /* ถ้ามีการผูก collection และยังไม่มีสินค้าโหลดมา ให้โหลดผ่าน AJAX ทันที */
          const collectionHandle = response.collection?.handle || (typeof response.collection === 'string' ? response.collection : null);
          console.log('[KMA Chat] ตรวจพบ Collection Handle:', collectionHandle);
          
          if (!prods.length && collectionHandle) {
            const ajaxProducts = await API.getCollectionProducts(collectionHandle);
            console.log('[KMA Chat] ดึงสินค้าผ่าน AJAX สำเร็จ จำนวน:', ajaxProducts.length, ajaxProducts);
            /* ตัดจำนวนสินค้าไม่ให้เกิน limit */
            let limit = parseInt(response.product_limit, 10) || 8;
            prods = ajaxProducts.slice(0, limit);
          }
          
          if (response.message) Renderer.addBotBubble(response.message);
          
          if (prods.length) {
            Renderer.addCarousel(prods, p => {
              const norm = DataHelper.normalizeProduct(p);
              return norm ? Renderer._buildProductCardEl(norm, source) : null;
            });
          } else {
            console.warn('[KMA Chat] ไม่พบสินค้าใน Carousel หรือโหลดไม่ได้');
            Renderer.addEmptyState('ยังไม่มีสินค้าแนะนำในหมวดนี้ค่ะ', () => this.goHome());
          }
          break;
        }

        case 'button_menu': {
          if (response.message) Renderer.addBotBubble(response.message);
          const cardHandles2 = (response.related_cards || []).map(c => c.handle).filter(Boolean);
          const menuCards = DataHelper.sortItems(
            this._cards.filter(c => cardHandles2.includes(c.handle) && DataHelper.isActive(c))
          );
          if (menuCards.length) {
            Renderer.addMenuButtons(menuCards.map(c => ({ ...c })), card => {
              const url = card.cta_url || (card.collection?.onlineStoreUrl || (card.collection?.handle ? `/collections/${card.collection.handle}` : '#'));
              const isExt = url.startsWith('http') && !url.includes(Config.shopDomain || '');
              Renderer.addLinkButton(card.cta_label || card.title, url, isExt);
            });
          }
          break;
        }

        case 'order_tracking':
        case 'tracking':
        case 'link': {
          const msg = response.message || 'ต้องการตรวจสอบสถานะคำสั่งซื้อใช่ไหมคะ?\nสามารถตรวจสอบได้จากหน้าติดตามพัสดุ';
          Renderer.addBotBubble(msg);
          const url = response.cta_url || Config.trackingUrl || '/pages/order-tracking';
          const label = response.cta_label || 'ตรวจสอบสถานะคำสั่งซื้อ';
          const isExt = url.startsWith('http') && !url.includes(Config.shopDomain || '');
          Renderer.addLinkButton(label, url, isExt, () => Analytics.clickTracking());
          break;
        }

        default:
          if (response.message) Renderer.addBotBubble(response.message);
          if (response.cta_url) {
            const isExt = response.cta_url.startsWith('http') && !response.cta_url.includes(Config.shopDomain || '');
            Renderer.addLinkButton(response.cta_label || 'ดูรายละเอียด', response.cta_url, isExt);
          }
      }
    },

    /* ── Carousel of generic cards ── */
    async _renderCarouselOfCards(cards, source) {
      const self = this;
      Renderer.addCarousel(cards, card => {
        const imgUrl = card.image?.url || card.image?.image?.url || '';
        const imgAlt = card.image_alt  || card.image?.altText    || card.title || '';
        
        let ctaUrl = card.cta_url
          || card.product?.onlineStoreUrl
          || (card.product?.handle ? `/products/${card.product.handle}` : '')
          || (card.collection?.onlineStoreUrl || (card.collection?.handle ? `/collections/${card.collection.handle}` : ''));
        
        if (ctaUrl.includes('/en/collections/')) ctaUrl = ctaUrl.replace('/en/collections/', '/collections/');
        if (ctaUrl.includes('/en/products/')) ctaUrl = ctaUrl.replace('/en/products/', '/products/');

        const isExt = ctaUrl.startsWith('http') && !ctaUrl.includes(Config.shopDomain || '');
        const el    = document.createElement('div');
        el.className = 'kma-chat-card' + (ctaUrl ? ' kma-chat-card--clickable' : '');

        let imgMarkup = '';
        if (imgUrl) {
          if (ctaUrl) {
            imgMarkup = `<a href="${Renderer._escAttr(ctaUrl)}" class="kma-chat-card__image-link" ${isExt ? 'target="_blank" rel="noopener noreferrer"' : ''}>
              <div class="kma-chat-card__image-wrap">
                <img src="${Renderer._escAttr(imgUrl)}" alt="${Renderer._escAttr(imgAlt)}" class="kma-chat-card__image" loading="lazy">
              </div>
            </a>`;
          } else {
            imgMarkup = `<div class="kma-chat-card__image-wrap">
              <img src="${Renderer._escAttr(imgUrl)}" alt="${Renderer._escAttr(imgAlt)}" class="kma-chat-card__image" loading="lazy">
            </div>`;
          }
        }

        const buttonLabel = card.cta_label || (ctaUrl ? 'ดูโปรโมชั่นนี้' : '');

        el.innerHTML = `
          ${imgMarkup}
          <div class="kma-chat-card__body">
            ${card.title       ? `<p class="kma-chat-card__title">${Renderer._esc(card.title)}</p>`       : ''}
            ${card.description ? `<p class="kma-chat-card__desc">${Renderer._esc(card.description)}</p>` : ''}
            ${ctaUrl && buttonLabel ? `<a href="${Renderer._escAttr(ctaUrl)}" class="kma-chat-cta" ${isExt ? 'target="_blank" rel="noopener noreferrer"' : ''}>${Renderer._esc(buttonLabel)}</a>` : ''}
          </div>`;

        el.querySelectorAll('a').forEach(a => {
          a.addEventListener('click', () => {
            Analytics.promotionClick(card.handle || card.title || '');
          });
        });

        return el;
      });
    },

    /* ── Navigation ── */
    goBack() {
      Analytics.back();
      State.popHistory(); /* remove current */
      State.popHistory(); /* remove previous (will re-execute it) */
      const history = State.get('history');
      this._updateNav();
      Renderer.clearMessages();
      const greetText = isEn ? (Config.greetingEn || t('greetingBox3')) : (Config.greeting || t('greetingBox3'));
      Renderer.addBotBubble(greetText);
      if (!history.length) {
        this._showMainMenu();
      } else {
        const target = history[history.length - 1];
        State.pushHistory(target); /* push back since _executeNode doesn't push */
        this._updateNav();
        this._executeNode(target);
      }
    },

    async goHome() {
      Analytics.returnHome();
      State.clearHistory();
      this._updateNav();

      /* ส่งข้อความฝั่งผู้ใช้ */
      Renderer.addUserBubble(t('userBackHome'));

      /* Typing เล็กน้อยเพื่อความนุ่มนวล */
      const typing = Renderer.addTypingIndicator();
      await this._wait(TYPING_MS);
      Renderer.removeTypingIndicator(typing);

      /* ข้อความฝั่งแชทบอท */
      const promptMsg = t('backPrompt');
      Renderer.addBotBubble(promptMsg, true);

      /* แสดง Choices เมนูหลัก */
      await this._showMainMenu();
    },

    _updateNav() {
      const nav     = document.getElementById('kma-chat-nav');
      const history = State.get('history') || [];
      if (!nav) return;
      if (history.length > 0) nav.removeAttribute('hidden');
      else                    nav.setAttribute('hidden', '');
    },

    _wait(ms) { return new Promise(r => setTimeout(r, ms)); }
  };

  /* ══════════════════════════════════════════════════════════
     INIT — รัน Widget เมื่อ DOM พร้อม
     ══════════════════════════════════════════════════════════ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Widget.init());
  } else {
    Widget.init();
  }

})();
